<template>
  <div class="col-lg-10 col-12 ">
    <div v-if="showEditar == false && showDetalle == false && !noMoreUsers">
      <div class="row">
        <div class="col-12">
          <div
            class="contenidoSearch custom-inputsearch"
            :id="field.key"
            v-for="field in fields"
            :key="field.key"
          >
            <i class="icon-search"></i>
            <input
              v-model="filters[field.key]"
              @input="filters[field.key] = $event.target.value.toLowerCase()"
              maxlength="20"
              :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.buscarUSuario')"
            />
          </div>
        </div>

        <div v-if="device === 'mobile' && !noMoreUsers" class="col-sm-12 col-lg-6 text-left mb-3">
          <span
            v-if="userTypeP == 'SUPER_ADMIN' || (userTypeP == 'ADMIN' && createModule)"
            @click="
              crearUsuario();
              resetCreation();
            "
            class="link pointer bold"
          >
            <i class="icon-user-add link"></i>
            {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.crearNewUsuario") }}
          </span>
        </div>

        <div class="col-sm-12 col-lg-6" v-if="!noMoreUsers">
          <!-- Filtro por orden -->
          <div class="filtro-orden relative" v-click-outside="outsideFiltro">
            <span class="azulBase">
              <b class="filtrado" @click="[(infoPersonal.filtroUsuario = true)]">
                {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.usuWithInicial") }}:

                <input
                  class="elipse"
                  type="text"
                  :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.todos')"
                  @click="[(infoPersonal.filtroUsuario = true)]"
                  v-model="filtroUsuarioDado"
                  readonly
                />
                <i
                  class="search-icons search-Custom icon-unfold-more pointer"
                  @click="[(infoPersonal.filtroUsuario = true)]"
                  v-if="!infoPersonal.filtroUsuario"
                ></i>
                <i
                  class="search-icons search-Custom icon-close pointer"
                  v-if="infoPersonal.filtroUsuario"
                  @click.stop="
                    filtroUsuarioDado = '';
                    onThere();
                    infoPersonal.filtroUsuario = false;
                  "
                ></i>
              </b>
            </span>
            <div
              class="card buscadorCardTitulo buscadorCustom vb"
              v-if="infoPersonal.filtroUsuario"
              v-bar
            >
              <div>
                <div
                  class="buscador"
                  v-for="filtro in infoPersonal.filtroUsuarios"
                  :key="filtro.id"
                >
                  <p
                    class="mb-1 nombre"
                    @click="
                      [
                        (filtroUsuarioDado = filtro.nombre),
                        (infoPersonal.filtroUsuario = false),
                        (titulo = 0),
                        onHere()
                      ]
                    "
                    v-html="$options.filters.resalt(filtro.nombre, filtroUsuarioDado)"
                  ></p>
                </div>
              </div>
            </div> 
          </div>
        </div>
        <div v-if="device === 'desktop' && !noMoreUsers" class="col-sm-12 col-lg-6 text-right pb-5">
          <span
            v-if="userTypeP == 'SUPER_ADMIN' || (userTypeP == 'ADMIN' && createModule)"
            @click="
              crearUsuario();
              resetCreation();
            "
            class="link pointer bold"
          >
            <i class="icon-user-add link"></i>
            {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.crearNewUsuario") }}
          </span>
        </div>
      </div>
      <Loader v-if="enableLoader" />
      <b-table
        v-if="!noMoreUsers && !temporaryTable && !enableLoader"
        show-empty
        :empty-text="$t('language.posadasCorporate.politicasViaje.noRegistros')"
        striped
        hover
        responsive
        :fields="fields"
        :items="filtered"
        id="my-table"
        class="mb-4"
        :per-page="perPage"
      :current-page="currentPage"
      >
        <span slot="[confirm]" slot-scope="data" v-html="data.value"></span>
        <template v-if="noOptions" v-slot:cell(options)="row">
          <i
            @click="(policiesS = []), goDetailUser(row)"
            v-b-popover.hover.top="
              $t('language.posadasCorporate.tablaUsuariosRegistrados.tableTooltip.detUsuario')
            "
            class="link pointer icon-avanzada icon-doc-detail"
          ></i>
          <i
            @click="(policiesS = []), modificarUsuario(row)"
            v-b-popover.hover.top="
              $t('language.posadasCorporate.tablaUsuariosRegistrados.tableTooltip.editUsuario')
            "
            class="link pointer icon-avanzada icon-edit"
          ></i>
          <i
            @click="showModalEliminar(row.item.userName)"
            v-b-popover.hover.top="
              $t('language.posadasCorporate.tablaUsuariosRegistrados.tableTooltip.eliUsuario')
            "
            class="link pointer icon-avanzada icon-trash"
          ></i>
        </template>
      </b-table>

      <b-pagination
        v-if="filtered.length >= perPage && !noMoreUsers && !temporaryTable && !enableLoader"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        align="right"
        size="sm"
        class="mb-5"
      /> 
    </div>

    <!-- Acción ver detalle de usuario -->
    <div class="detalle-usuario" v-if="showDetalle == true">
      <h5 class="tab-accion-titulo">
        {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.detUsuario") }}
      </h5>
      <div class="detalle-usuario__fila">
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.nomUsuario")
              }}</b>
              <span class="">{{ userNameD }}</span>
            </p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.nombre")
              }}</b>
              <span class="">{{ userCommonName }} {{ userLastName }} {{ userLastName2 }}</span>
            </p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.numEmpleado")
              }}</b>
              <span class="">{{ numEmpD }}</span>
            </p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.email") }}</b>
              <span class="wb-break">{{ emailD }}</span>
            </p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.tipoUsuario")
              }}</b>
              <span class="">{{ typeUserD }}</span>
            </p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <p>
              <b>{{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.estatus")
              }}</b>
              <span class="">{{ activeUserD }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="detalle-usuario__fila">
        <div class="row">
          <div class="col-md-12">
            <h6 class="detalle-usuario__subtitulo PC-text--size16">
              {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.propiedades") }}
            </h6>
          </div>
          <div class="col-md-6" v-for="property in propertiesListD" :key="property.id">
            <p>· {{ property.description }}</p>
          </div>
          <div class="col-md-6">
          </div>
        </div>
      </div>
      <div class="detalle-usuario__fila">
        <div class="row" v-if="creditType != []">
          <div class="col-md-12">
            <h6 class="detalle-usuario__subtitulo PC-text--size16">
              {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.tipoCredito") }}
            </h6>
          </div>
          <div class="col-md-6" v-for="creditType in creditType" :key="creditType.id">
            <p>· {{ creditType.description }}</p>
          </div>
        </div>
      </div>
      <div class="detalle-usuario__fila">
        <div class="row">
          <div class="col-md-12">
            <h6 class="detalle-usuario__subtitulo PC-text--size16">
              {{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.permisoTarifas")
              }}
            </h6>
          </div>
          <div class="col-md-6">
            <p v-if="verTarifasNeg">
              ·
              {{
                $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.verTarifasNeg")
              }}
            </p>
            <p v-if="verDispo">
              · {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.verDispo") }}
            </p>
          </div>
        </div>
      </div>
      <div class="detalle-usuario__fila">
        <div class="row">
          <div class="col-md-12">
            <h6 class="detalle-usuario__subtitulo PC-text--size16">
              {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.polViaje") }}
            </h6>
          </div>
          <div class="col-md-6" v-for="policy in policiesD" :key="policy.id">
            <p>· {{ policy.name }}</p>
          </div>
        </div>
      </div>
      <div class="detalle-usuario__fila">
        <div class="row botones d-flex justify-content-end">
          <div class="col-12 col-lg-4 botonesInfo order-2 order-lg-1">
            <button class="secondary-button" @click="reset()">
              {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.verDetalle.regresar") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Acción editar información -->
    <div class="editar-usuario" v-if="showEditar">
      <h5 class="tab-accion-titulo">{{ titleNuevoUsuario }}</h5>
      <div class="steps">
        <div class="pasos d-inline-block" :class="datosGeneralesPasos ? 'ativePaso' : ''">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.datosGenerales") }}
          <i class=" icon-right"></i>
        </div>
        <div class="pasos d-inline-block" :class="!datosGeneralesPasos ? 'ativePaso' : ''">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.confiPerfil") }}
        </div>
      </div>
      <form @submit.prevent="">
        <div class="datos" v-if="datosGeneralesForm">
          <!-- Datos generales -->
          <div class="dato">
            <div class="datoBody" role="tablist">
              <!-- Datos personales -->
              <div class="campos">
                <p
                  class="tituloDatos"
                  v-if="infoPersonal.datosPersonales"
                  :class="infoPersonal.iconoActivo == 0 ? 'camposActive' : ''"
                  @click="
                    infoPersonal.iconoActivo == 0
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 0)
                  "
                  v-b-toggle="'datosPersonales'"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <i class="icon-user"></i>
                  {{
                    $t(
                      "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.datosPersonales"
                    )
                  }}
                  <i
                    class="navi icon-up"
                    :class="infoPersonal.iconoActivo == 0 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="infoPersonal.iconoActivo == 0 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!infoPersonal.datosPersonales"
                  @click="
                    infoPersonal.iconoActivo == 0
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 0)
                  "
                  v-b-toggle="'datosPersonales'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t(
                      "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.datosPersonales"
                    )
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(infoPersonal.datosPersonales = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.editar")
                    }}</span
                  >
                </p>

                <!-- Formulario -->
                <b-collapse
                  class="datos"
                  id="datosPersonales"
                  v-model="visible"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div class="row">
                    <div
                      class="form-element col-12 col-lg-4"
                      v-if="!enableEditOptions"
                      v-click-outside="outsideSearch"
                    >
                      <label>{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.perfilesExistentes"
                        )
                      }}</label>
                      <div class="contenidoSearch" @click="[(infoPersonal.perfil = true)]">
                        <i class="search-icons icon-search" v-if="!infoPersonal.perfil"></i>
                        <i
                          class="search-icons icon-close pointer"
                          v-if="infoPersonal.perfil"
                          @click="infoPersonal.perfilDado = ''"
                        ></i>
                        <input
                          class="elipse"
                          type="text"
                          :placeholder="
                            $t(
                              'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.seleccionar'
                            )
                          "
                          @click="filteredListPerfiles"
                          v-model="infoPersonal.perfilDado"
                        />
                      </div>

                      <div class="card buscadorCardTitulo vb" v-if="infoPersonal.perfil" v-bar>
                        <div>
                          <div
                            class="buscador"
                            v-for="listaPerfil in filteredListPerfiles"
                            :key="listaPerfil.id"
                          >
                            <p
                              class="mb-1 nombre"
                              @click="
                                [
                                  cambiaPerfil(listaPerfil.nombre, listaPerfil.guestProfileId),
                                  (infoPersonal.perfil = false)
                                ]
                              "
                              v-html="
                                $options.filters.resalt(listaPerfil.nombre, infoPersonal.perfilDado)
                              "
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-element col-12 col-lg-4">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.nomUsuario"
                          )
                        }}*</label
                      >
                      <input
                        type="text"
                        v-model="realUserName"
                        v-lowercase
                        :disabled="enableEditOptions"
                        maxlength="20"
                        :class="{ 'is-invalid': !realUserNamePass }"
                        id="campoUsuarioId"
                      />
                       <span class="notas" v-if="!realUserNamePass">{{$t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.usersInvalid')}}</span>
                    </div>
                  </div>

                  <div class="row segundaIlera">
                    <!-- Nombre -->
                    <div class="form-element col-12 col-lg-4">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.nombre"
                          )
                        }}*</label
                      >
                      <input
                        type="text"
                        v-model="realFirstName"
                        maxlength="26"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="form-element col-6 col-lg-4">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.apeParterno"
                          )
                        }}*</label
                      >
                      <input
                        type="text"
                        v-model="realLastName"
                        maxlength="26"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="form-element col-6 col-lg-4">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.apeMaterno"
                        )
                      }}</label>
                      <input
                        type="text"
                        v-model="realLastName2"
                        maxlength="26"
                        class="inputUppercase"
                      />
                    </div>

                    <!-- informacion empresa -->
                    <div class="form-element col-12 col-lg-3">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.numEmpleadoAgente"
                        )
                      }}</label>
                      <input
                        type="text"
                        :placeholder="$t('language.posadasCorporate.generals.caracteresMax20')"
                        maxlength="20"
                        v-model="realNumeroEmple"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="form-element col-6 col-lg-3">
                      <label for="">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.numeroFR")
                      }}</label>
                      <input
                        type="text"
                        :placeholder="$t('language.posadasCorporate.generals.caracteresMax12')"
                        maxlength="12"
                        v-model="realNumeroFiesta"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="form-element col-6 col-lg-3">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.numAprClub"
                        )
                      }}</label>
                      <input
                        type="text"
                        :placeholder="$t('language.posadasCorporate.generals.caracteresMax18')"
                        maxlength="18"
                        v-model="realNumeroApreciare"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="form-element col-12 col-lg-3">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.centroCostos"
                        )
                      }}</label>
                      <input
                        type="text"
                        :placeholder="$t('language.posadasCorporate.generals.caracteresMax20')"
                        maxlength="20"
                        v-model="realNumeroCentro"
                        class="inputUppercase"
                      />
                    </div>
                    <div class="col-12">
                      <label for="" class="notas"
                        >*{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.camposRequeridos"
                          )
                        }}</label
                      >
                    </div>

                    <div class="col-12 col-lg-6 botonesInfo">
                      <button
                        class="button"
                        @click="
                          [
                            (infoPersonal.iconoActivo = 1),
                            (infoPersonal.datosPersonales = false),
                            (infoPersonal.datosContacto = true),
                            validateUser()
                          ]
                        "
                        :disabled="isDisabledPersonales"
                      >
                        {{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.continuarDatContacto"
                          )
                        }}
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Datos de contacto -->
              <div class="campos">
                <p
                  class="tituloDatos"
                  v-if="infoPersonal.datosContacto"
                  :class="infoPersonal.iconoActivo == 1 ? 'camposActive' : ''"
                  @click="
                    infoPersonal.iconoActivo == 1
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 1)
                  "
                  v-b-toggle="'datosContacto'"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <i class="icon-location"></i>
                  {{
                    $t(
                      "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.datosContacto"
                    )
                  }}
                  <i
                    class="navi icon-up"
                    :class="infoPersonal.iconoActivo == 1 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="infoPersonal.iconoActivo == 1 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!infoPersonal.datosContacto"
                  @click="
                    infoPersonal.iconoActivo == 1
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 1)
                  "
                  v-b-toggle="'datosContacto'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t(
                      "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.datosContacto"
                    )
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(infoPersonal.datosContacto = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.editar")
                    }}</span
                  >
                </p>

                <!-- Formulario -->
                <b-collapse
                  class="datos"
                  id="datosContacto"
                  accordion="my-accordion"
                  v-model="contactsAcord"
                  role="tabpanel"
                >
                  <div class="row contactoInfo">
                    <!-- Tipo de teléfono -->
                    <div class="form-element col-12 col-lg-6">
                      <label
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.tipoTelefono"
                          )
                        }}*</label
                      ><br />
                      <label for="celular" class="col-4 pl-0 radio">
                        <input
                          type="radio"
                          id="celular"
                          class="hidden"
                          value="MOB"
                          v-model="pickedTelelefonoUf"
                        />
                        <span class="label"></span
                        ><span class="moneda">{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.celular"
                          )
                        }}</span>
                      </label>
                      <label for="casa" class="col-4 pl-0 radio">
                        <input
                          type="radio"
                          id="casa"
                          class="hidden"
                          value="HOM"
                          v-model="pickedTelelefonoUf"
                        />
                        <span class="label"></span
                        ><span class="moneda">{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.casa1")
                        }}</span>
                      </label>
                      <label for="oficina" class="col-4 pl-0 radio">
                        <input
                          type="radio"
                          id="oficina"
                          class="hidden"
                          value="BUS"
                          v-model="pickedTelelefonoUf"
                        />
                        <span class="label"></span
                        ><span class="moneda">{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.oficina1"
                          )
                        }}</span>
                      </label>
                    </div>

                    <!-- Núm. telefónico Cel-->
                    <div class="form-element col-12 col-lg-6">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.numTelefonico"
                          )
                        }}*</label
                      >
                      <input
                        type="text"
                        :placeholder="
                          $t(
                            'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.digitos10'
                          )
                        "
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        maxlength="10"
                        v-model="infoPersonal.numTelefonico"
                        v-onlyNumbers
                      />
                    </div>

                    <!-- Correo electrónico* -->
                    <div class="form-element col-6 col-lg-4">
                      <label for=""
                        >{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.email")
                        }}*</label
                      >
                      <input
                        type="text"
                        :placeholder="
                          $t(
                            'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ejemplo'
                          ) +
                            '@' +
                            $t(
                              'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.correo'
                            ) +
                            '.com'
                        "
                        v-model="mailContacto"
                        v-email
                        maxlength="50"
                        :class="{ 'is-invalid': !$v.mailContacto.email }"
                      />
                      <span class="notas" v-if="!$v.mailContacto.email">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailInvalid"
                        )
                      }}</span>
                    </div>

                    <div class="form-element col-6 col-lg-4">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.confEmail"
                          )
                        }}*</label
                      >
                      <input
                        type="text"
                        :placeholder="
                          $t(
                            'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ejemplo'
                          ) +
                            '@' +
                            $t(
                              'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.correo'
                            ) +
                            '.com'
                        "
                        v-model="mailContactoConfirm"
                        v-email
                        maxlength="50"
                        :class="{ 'is-invalid': !$v.mailContactoConfirm.email || !emailMatch }"
                      />
                      <span class="notas" v-if="!$v.mailContactoConfirm.email"
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailInvalid"
                          )
                        }}.</span
                      >
                      <span class="notas" v-if="!emailMatch">
                        {{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailCopy"
                          )
                        }}.
                      </span>
                    </div>

                    <div class="form-element col-6 col-lg-4">
                      <label for="">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.text1")
                      }}</label>
                      <input
                        type="text"
                        :placeholder="
                          $t(
                            'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ejemplo'
                          ) +
                            '@' +
                            $t(
                              'language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.correo'
                            ) +
                            '.com'
                        "
                        v-model="infoPersonal.mailContactoConfirmacion"
                        v-email
                        maxlength="50"
                        :class="{ 'is-invalid': !$v.infoPersonal.mailContactoConfirmacion.email }"
                      />
                      <span class="notas" v-if="!$v.infoPersonal.mailContactoConfirmacion.email">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailInvalid"
                        )
                      }}</span>
                      <span class="notas"
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.copia1Confirmacion"
                          )
                        }}: reservacionescorporate@posadas.com</span
                      >
                    </div>

                    <!-- direccion -->
                    <!-- tipo direccion -->
                    <div class="form-element col-12">
                      <label class="detalle-usuario__subtitulo PC-text--size16">{{
                        $t("language.posadasCorporate.reservacionesRegistro.newAddress")
                      }}</label
                      ><br />
                    </div>

                    <!-- Calle numero -->
                    <div class="form-element col-sm-8 col-lg-6">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.calleNumero"
                        )
                      }}</label>
                      <input
                        type="text"
                        v-model="realAddress"
                        maxlength="50"
                        class="inputUppercase"
                      />
                    </div>

                    <div class="form-element col-6 col-lg-3">
                      <label for="">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.colonia")
                      }}</label>
                      <input type="text" maxlength="50" v-model="realTown" class="inputUppercase" />
                    </div>

                    <!-- Código Postal -->
                    <div class="form-element col-sm-4 col-lg-3">
                      <label for="">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.codigoPostal"
                        )
                      }}</label>
                      <input type="text" maxlength="10" v-model="realZip" class="inputUppercase" />
                    </div>

                    <!-- Pais -->
                    <div class="form-element col-lg-3" v-click-outside="outsidePais">
                      <label
                        >{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.pais")
                        }}*</label
                      >
                      <div class="contenidoSearch" @click="[(infoPersonal.pais = true)]">
                        <i class="search-icons icon-search" v-if="!infoPersonal.pais"></i>
                        <i class="search-icons icon-close pointer" v-if="infoPersonal.pais" @click="[realCountry = '', resetSelectedPais()]"></i>
                        <input
                          class="elipse"
                          type="text"
                          :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.seleccionar')"
                          @click="filteredListPaises"
                          v-model="realCountry"
                        />
                      </div>

                      <div class="card buscadorCard vb" v-if="infoPersonal.pais" v-bar>
                        <div>
                          <div class="buscador" v-for="pais in filteredListPaises" :key="pais.id">
                            <p
                              class="mb-1 nombre"
                              @click="[cambiaPais(pais.nombre), (infoPersonal.pais = false)]"
                              v-html="$options.filters.resalt(pais.nombre, realCountry)"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Estado -->
                    <div class="form-element col-lg-3" v-click-outside="outsideEstado">
                      <label for="">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.estado")
                      }}</label>
                      <div class="contenidoSearch">
                        <i class="search-icons icon-search" v-if="!infoPersonal.estado"></i>
                        <i class="search-icons icon-close pointer" v-if="infoPersonal.estado" @click="infoPersonal.estadoSeleccionado = ''"></i>
                        <input
                          class="elipse"
                          type="text"
                          :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.seleccionar')"
                          :disabled="isDisabledEstado"
                          @click="filteredListEstado; infoPersonal.estado = true"
                          v-model="infoPersonal.estadoSeleccionado"
                        />
                      </div>

                      <div class="card buscadorCard vb" v-if="infoPersonal.estado" v-bar>
                        <div>
                          <div
                            class="buscador"
                            v-for="estado in filteredListEstado"
                            :key="estado.id"
                          >
                            <p
                              class="mb-1 nombre"
                              @click="[cambiaEstado(estado.nombre), (infoPersonal.estado = false)]"
                              v-html="
                                $options.filters.resalt(
                                  estado.nombre,
                                  infoPersonal.estadoSeleccionado
                                )
                              "
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Estado -->
                    <div class="form-element col-lg-3">
                      <label for="">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ciudad")
                      }}</label>
                      <input type="text" maxlength="50" v-model="realCity" class="inputUppercase" />
                    </div>

                    <div class="col-12 mb-2">
                      <label for="" class="notas"
                        >*{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.camposRequeridos"
                          )
                        }}</label
                      >
                    </div>

                    <!-- Boton -->
                    <div
                      class="col-12 col-lg-6 botonesInfo"
                      v-b-toggle="'datosContacto'"
                      v-b-toggle.contrasena
                    >
                      <button
                        class="button"
                        @click="
                          [(infoPersonal.iconoActivo = 2), (infoPersonal.datosContacto = false)]
                        "
                        :disabled="isDisabledContacto"
                      >
                        {{ titleBtnContraseña }}
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Contraseña registrada -->
              <div class="campos acompanante">
                <p
                  class="tituloDatos"
                  v-if="infoPersonal.contrasena"
                  :class="infoPersonal.iconoActivo == 2 ? 'camposActive' : ''"
                  @click="
                    infoPersonal.iconoActivo == 2
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 2)
                  "
                  v-b-toggle="'contrasena'"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <i class="icon-lock"></i>
                  {{ titleTitleContraseña }}
                  <i
                    class="navi icon-up"
                    :class="infoPersonal.iconoActivo == 2 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="infoPersonal.iconoActivo == 2 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!infoPersonal.contrasena"
                  @click="
                    infoPersonal.iconoActivo == 2
                      ? (infoPersonal.iconoActivo = 100)
                      : (infoPersonal.iconoActivo = 2)
                  "
                  v-b-toggle="'contrasena'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{ titleTitleContraseña }}
                  <span class="editarDatos pointer" @click="[(infoPersonal.contrasena = true)]">{{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.editar")
                  }}</span>
                </p>

                <!-- Formulario -->
                <b-collapse class="datos" id="contrasena" accordion="my-accordion" role="tabpanel">
                  <div class="row">
                    <!-- Nombre -->
                    <div class="form-element col-12 col-lg-6 relative">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contrasena1"
                          )
                        }}*</label
                      >
                      <input
                        id="password"
                        class="form-control password"
                        :class="{ 'is-invalid': !passwordNot10M }"
                        :type="passwordFieldType"
                        @click.stop="isModalPass = false"
                        @blur="outsidePass"
                        v-model="contrasenaUsuario"
                        maxlength="20"
                      />
                      <span
                        class="__eyeIcon buttonEye"
                        :class="[openEye]"
                        @click="switchVisibility"
                      ></span>
                    </div>
                    <div class="form-element col-12 col-lg-6 relative">
                      <label for=""
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.confContrasena"
                          )
                        }}*</label
                      >
                      <input
                        id="passwordConfirm"
                        class="form-control password"
                        :class="{ 'is-invalid': !passwordMatch || !passwordNot10 }"
                        :type="passwordFieldTypeConfirm"
                        @click.stop="isModalPass = false"
                        @blur="outsidePass"
                        v-model="contrasenaConfirma"
                        maxlength="20"
                      />
                      <span
                        class="__eyeIcon buttonEye"
                        :class="[openEyeConfirm]"
                        @click="switchVisibilityConfirm"
                      ></span>
                      <span class="notas" v-if="!passwordMatch">
                        {{ $t("language.posadasCorporate.infoPersonalEditar.theSame") }}. 
                      </span>
                    </div>
                    <div class="col-12 mb-2">
                      <label
                        for=""
                        class="notas"
                        v-if="contrasenaConfirma.length < 10 || contrasenaUsuario.length < 10"
                      >
                        {{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.text2")
                        }} </label
                      ><br />
                      <label for="" class="notas"
                        >*{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.camposRequeridos"
                          )
                        }}</label
                      >
                    </div>

                    <div v-if="enableUser && enableEditOptions" class="col-12 mb-2">
                      <input type="checkbox" v-model="infoPersonal.desHabilitarUsuario" />
                      <label v-if="detailUser.active">{{
                        $t("language.posadasCorporate.infoPersonalEditar.text2")
                      }}</label>
                      <label v-if="!detailUser.active">{{ changeUnableMessage }}</label>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>

          <div class="row ">
            <div class="col-12 col-lg-4 botonesInfo order-2 order-lg-1">
              <button
                class="secondary-button"
                @click="
                  reset();
                  infoPersonal.perfilDado = '';
                  codeCountry = '';
                  realCountry = '';
                  infoPersonal.estadoSeleccionado = '';
                  codeState = '';
                  infoPersonal.desHabilitarUsuario = false;
                  resetSelectedPais();
                "
              >
                {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.cancelar") }}
              </button>
            </div>
            <div class="col-12 col-lg-5 col-xl-5 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
              <button
                v-if="!enableEditOptions"
                class="button"
                @click="
                  (datosGeneralesForm = false),
                    (datosGeneralesPasos = false),
                    goConfigUser()
                "
                :disabled="isDisabledFormulario"
              >
                {{
                  $t(
                    "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contConfiPerfil"
                  )
                }}
              </button>
              <button
                v-if="enableEditOptions"
                class="button"
                @click="
                  (datosGeneralesForm = false),
                    (datosGeneralesPasos = false),
                    goConfigUser()
                "
                :disabled="isDisabledFormularioEdition"
              >
                {{
                  $t(
                    "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contConfiPerfil"
                  )
                }}
              </button>
            </div>
          </div>
        </div>

        <!-- Configuración de perfil -->
        <div class="datos" v-else>
          <div class="dato">
            <div class="datoBody">
              <!-- Tipos de usuario -->
              <div class="campos">
                <p
                  class="tituloDatos"
                  v-if="configPerfil.datosTipoUsuario"
                  :class="configPerfil.iconoActivo == 0 ? 'camposActive' : ''"
                  @click="
                    configPerfil.iconoActivo == 0
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 0)
                  "
                  v-b-toggle="'datosTipoUsuario'"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <i class="icon-user"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.tipoUsuario")
                  }}
                  <i
                    class="navi icon-up"
                    :class="configPerfil.iconoActivo == 0 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="configPerfil.iconoActivo == 0 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!configPerfil.datosTipoUsuario"
                  @click="
                    configPerfil.iconoActivo == 0
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 0)
                  "
                  v-b-toggle="'datosTipoUsuario'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.tipoUsuario")
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(configPerfil.datosTipoUsuario = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.editar")
                    }}</span
                  >
                </p>

                <b-collapse
                  class="datos"
                  id="datosTipoUsuario"
                  visible
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <div class="row">
                    <!-- Perfiles Existentes -->
                    <div v-if="enableAdmin" class="form-element col-12">
                      <label for="administrador" class="radio">
                        <span class="tipo-usuario">{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.administrador"
                          )
                        }}</span>
                      </label>

                      <div class="row form-grupo" v-if="checkedUser === 'admin'">
                        <div class="col-12">
                          <label>{{
                            $t(
                              "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text3"
                            )
                          }}</label>
                        </div>

                        <!-- WS -->
                        <div
                          class="col-12 col-lg-6"
                          v-for="property in superAdProperties"
                          :key="property.key"
                        >
                          <label class="" for="">
                            <input type="checkbox" v-model="property.value" />
                            <span>{{ property.description }}</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div v-if="enableAgent && mayCreateAgent" class="form-element col-12">

                      <label v-if="mayCreateAgent && mayCreateUserGeneric" class="radio">
                        <input type="radio"  class="hidden" value="AGENTE" v-model="selectedUser">
                        <span class="label"></span><span class="tipo-usuario">{{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.agente")}}</span>
                      </label>
                      


                      <label v-if="mayCreateAgent && !mayCreateUserGeneric" for="agente" class="radio">
                        <span class="tipo-usuario">
                          {{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.agente")}}
                        </span>
                      </label>

                      <div v-if="mayCreateAgent" class="row form-grupo">
                        <div class="col-12">
                          <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.unicReservas")}}</label>
                        </div>
                        <div class="col-12 col-lg-6">
                          <label class="" for="">&nbsp;&nbsp;&nbsp;&nbsp;
                            <input :disabled="selectedUser=='AGENTE_GENERICO'" type="checkbox" value="132" v-model="modifyUsers" />
                            <span>{{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.modCanReservas")}}</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div v-if="enableAgent && mayCreateUserGeneric" class="form-element col-12">

                      <label v-if="mayCreateAgent && mayCreateUserGeneric" class="radio">
                        <input type="radio"  class="hidden" value="AGENTE_GENERICO" v-model="selectedUser">
                        <span class="label"></span><span class="tipo-usuario">{{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.agenteGenerico")}}</span>
                      </label>

                      <label v-if="!mayCreateAgent && mayCreateUserGeneric" for="agenteGenerico" class="radio">
                        <span class="tipo-usuario">
                          {{$t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.agenteGenerico")}}
                        </span>
                      </label>
                      
                      <div v-if="mayCreateUserGeneric" class="row form-grupo">
                        <div class="col-12">
                          <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                            $t(
                              "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.unicReservas"
                            )
                          }}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row pt-24">
                    <!-- Boton -->
                    <div
                      class="col-12 col-lg-6 botonesInfo"
                      v-b-toggle="'datosTipoUsuario'"
                      v-b-toggle.metodoPago
                    >
                      <button
                        class="button"
                        @click="
                          [(configPerfil.iconoActivo = 1), (configPerfil.datosTipoUsuario = false)]
                        "
                        :disabled="isDisabledUsuario"
                      >
                        {{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.contMetPag"
                          )
                        }}
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Metodos de pago -->
              <div class="campos">
                <p
                  class="tituloDatos"
                  v-if="configPerfil.datosMetodoPago"
                  :class="configPerfil.iconoActivo == 1 ? 'camposActive' : ''"
                  @click="
                    configPerfil.iconoActivo == 1
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 1)
                  "
                  v-b-toggle="'metodoPago'"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <i class="icon-credit-card"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.metodosPago")
                  }}
                  <i
                    class="navi icon-up"
                    :class="configPerfil.iconoActivo == 1 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="configPerfil.iconoActivo == 1 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!configPerfil.datosMetodoPago"
                  @click="
                    configPerfil.iconoActivo == 1
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 1)
                  "
                  v-b-toggle="'metodoPago'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.metodosPago")
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(configPerfil.datosMetodoPago = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.editar")
                    }}</span
                  >
                </p>

                <b-collapse
                  class="datos"
                  id="metodoPago"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <div class="row form-grupo mb-2" v-if="voucher1 || voucher2">
                    <div class="col-12">
                      <label class="m-0 detalle-usuario__subtitulo PC-text--size16 bold">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.voucher")
                      }}</label>
                    </div>

                    <div class="col-12">
                      <span class="PC-text--size14"
                        >{{ $t("language.posadasCorporate.paymentMethods.text6") }}.</span
                      >
                    </div>

                    <div class="col-sm-12 col-lg-2">
                      <label class="m-0 radio" for="voucherNinguno">
                        <input
                          type="radio"
                          id="voucherNinguno"
                          class="hidden"
                          value="Ninguno"
                          v-model="voucher"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
                          )
                        }}</span>
                      </label>
                    </div>
                    <div class="col-sm-12 col-lg-5" v-if="voucher1">
                      <label class="m-0 radio" for="tarifasNegociadas">
                        <input
                          type="radio"
                          id="tarifasNegociadas"
                          class="hidden"
                          value="125"
                          v-model="voucher"
                        />
                        <span class="label"></span>
                        <span>
                          {{
                            $t(
                              "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text4"
                            )
                          }}
                        </span>
                      </label>
                    </div>
                    <div class="sm-12 col-lg-5" v-if="voucher2">
                      <label class="m-0 radio" for="todasTarifas">
                        <input
                          type="radio"
                          id="todasTarifas"
                          class="hidden"
                          value="124"
                          v-model="voucher"
                        />
                        <span class="label"></span
                        ><span>
                          {{
                            $t(
                              "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text5"
                            )
                          }}
                        </span>
                      </label>
                    </div>
                  </div>

                  <div class="row form-grupo mb-2" v-if="credit1 || credit2">
                    <div class="col-12">
                      <label class="m-0 detalle-usuario__subtitulo PC-text--size16 bold">{{
                        $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.credito")
                      }}</label>
                    </div>

                    <div class="col-12">
                      <span class="PC-text--size14"
                        >{{ $t("language.posadasCorporate.paymentMethods.text34") }}.</span
                      >
                    </div>
                    <div class="col-sm-12 col-lg-2">
                      <label class="m-0 radio" for="limiteNinguno">
                        <input
                          type="radio"
                          id="limiteNinguno"
                          class="hidden"
                          value="Ninguno"
                          v-model="credito"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
                          )
                        }}</span>
                      </label>
                    </div>
                    <div class="col-sm-12 col-lg-5" v-if="credit1">
                      <label class="m-0 radio" for="limiteTarifaNegociada">
                        <input
                          type="radio"
                          id="limiteTarifaNegociada"
                          class="hidden"
                          value="118"
                          v-model="credito"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text6")
                        }}</span>
                      </label>
                    </div>
                    <div class="col-sm-12 col-lg-5" v-if="credit2">
                      <label class="m-0 radio" for="limiteTodasTarifas">
                        <input
                          type="radio"
                          id="limiteTodasTarifas"
                          class="hidden"
                          value="117"
                          v-model="credito"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text7")
                        }}</span>
                      </label>
                    </div>
                  </div>

                  <div class="row form-grupo mb-2" v-if="time1 || time2">
                    <div class="col-12">
                      <label class="m-0 detalle-usuario__subtitulo PC-text--size16 bold">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.tiempoLimite"
                        )
                      }}</label>
                    </div>
                    <div class="col-12">
                      <span class="PC-text--size14"
                        >{{ $t("language.posadasCorporate.paymentMethods.text31") }}.</span
                      >
                    </div>
                    <div class="col-sm-12 col-lg-2">
                      <label class="m-0 radio" for="creditNinguno">
                        <input
                          type="radio"
                          id="creditNinguno"
                          class="hidden"
                          value="Ninguno"
                          v-model="limite"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
                          )
                        }}</span>
                      </label>
                    </div>
                    <div class="col-sm-12 col-lg-5" v-if="time1">
                      <label class="m-0 radio" for="creditTarifaNegociada">
                        <input
                          type="radio"
                          id="creditTarifaNegociada"
                          class="hidden"
                          value="120"
                          v-model="limite"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text8")
                        }}</span>
                      </label>
                    </div>
                    <div class="col-sm-12 col-lg-5" v-if="time2">
                      <label class="m-0 radio" for="creditTodasTarifas">
                        <input
                          type="radio"
                          id="creditTodasTarifas"
                          class="hidden"
                          value="119"
                          v-model="limite"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.text9")
                        }}</span>
                      </label>
                    </div>
                  </div>

                  <div class="row pt-24">
                    <!-- Boton -->
                    <div
                      class="col-12 col-lg-6 botonesInfo"
                      v-b-toggle="'metodoPago'"
                      v-b-toggle.tarifas
                    >
                      <button
                        class="button"
                        @click="
                          [
                            (configPerfil.iconoActivo = 2),
                            (configPerfil.datosMetodoPago = false),
                            checkPolicyRightForAdmin(),
                            enablePolicies()
                          ]
                        "
                        :disabled="isDisabledPago"
                      >
                        {{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.contTarifasPol"
                          )
                        }}
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Tarifas y políticas -->
              <div class="campos">
                <p
                  class="tituloDatos"
                  v-if="configPerfil.datosTarifasPoliticas"
                  :class="configPerfil.iconoActivo == 2 ? 'camposActive' : ''"
                  @click="
                    configPerfil.iconoActivo == 2
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 2)
                  "
                  v-b-toggle="'tarifas'"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <i class="icon-politics"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.tarifasPol")
                  }}
                  <i
                    class="navi icon-up"
                    :class="configPerfil.iconoActivo == 2 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="configPerfil.iconoActivo == 2 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!configPerfil.datosTarifasPoliticas"
                  @click="
                    configPerfil.iconoActivo == 2
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 1)
                  "
                  v-b-toggle="'tarifas'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.tarifasPol")
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(configPerfil.datosTarifasPoliticas = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.editar")
                    }}</span
                  >
                </p>

                <b-collapse class="datos" id="tarifas" accordion="accordion-perfil" role="tabpanel">
                  <div class="row">
                    <div class="col-12">
                      <label class="detalle-usuario__subtitulo PC-text--size16">{{
                        $t(
                          "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.permisosSoTarifas"
                        )
                      }}</label>
                    </div>
                    <div class="col-12" v-if="userTypeP == 'SUPER_ADMIN' || adminRates">
                      <label class="" for="">
                        <input type="checkbox" v-model="showRatesValue" />
                        <span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.verTarifasNeg"
                          )
                        }}</span>
                      </label>
                    </div>
                    <div class="col-12" v-if="userTypeP == 'SUPER_ADMIN' || adminShowPublic">
                      <label for="">
                        <input type="checkbox" v-model="showPublicRatesValue" />
                        <span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.verDispo"
                          )
                        }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-12">
                      <label
                        v-if="hidePolicies"
                        class="detalle-usuario__subtitulo PC-text--size16"
                        >{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.polViaje"
                          )
                        }}</label
                      >
                    </div>

                    <div class="col-lg-4" v-for="(policy, index) in lists" :key="index">
                      <label v-if="hidePolicies" :for="policy.name">
                        <input
                          v-if="hidePolicies"
                          type="checkbox"
                          :id="policy.name"
                          v-model="policy.value"
                        />
                        <span v-if="hidePolicies">{{ policy.name }}</span>
                      </label>
                    </div>

                    <b-col v-if="perPagePols < policiesS.length" cols="12" lg="12" class="mt-4">
                      <b-pagination
                        v-model="currentPagePols"
                        :total-rows="policiesS.length"
                        :per-page="perPagePols"
                        align="right"
                      />
                    </b-col>
                  </div>
                  <div class="row pt-24">
                    <!-- Boton -->
                    <div
                      class="col-12 col-lg-6 botonesInfo"
                      v-b-toggle="'tarifas'"
                      v-if="enableProforma"
                      v-b-toggle.proforma
                    >
                      <button
                        class="button"
                        @click="
                          [
                            (configPerfil.iconoActivo = 3),
                            (configPerfil.datosTarifasPoliticas = false),
                          ]
                        "
                        :disabled="isDisabledPago"
                      >
                        {{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.continuarProforma"
                          )
                        }}
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- Proforma -->
              <div
                class="campos"
                v-if="
                  ls.get('Profile').data.profileId != 'POSADAS' &&
                    (enableProforma || userTypeP == 'SUPER_ADMIN')
                "
              >
                <p
                  class="tituloDatos"
                  v-if="configPerfil.datosProforma"
                  :class="configPerfil.iconoActivo == 3 ? 'camposActive' : ''"
                  @click="
                    configPerfil.iconoActivo == 3
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 3)
                  "
                  v-b-toggle="'proforma'"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <i class="icon-report"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.proforma")
                  }}
                  <i
                    class="navi icon-up"
                    :class="configPerfil.iconoActivo == 3 ? '' : 'oculto'"
                  ></i>
                  <i
                    class="navi icon-navigate-down"
                    :class="configPerfil.iconoActivo == 3 ? 'oculto' : ''"
                  ></i>
                </p>
                <p
                  class="tituloDatosEditar"
                  v-if="!configPerfil.datosProforma"
                  @click="
                    configPerfil.iconoActivo == 3
                      ? (configPerfil.iconoActivo = 100)
                      : (configPerfil.iconoActivo = 1)
                  "
                  v-b-toggle="'tarifas'"
                >
                  <i class="icon-check-rounded-fill"></i>
                  {{
                    $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.proforma")
                  }}
                  <span
                    class="editarDatos pointer"
                    @click="[(configPerfil.datosProforma = true)]"
                    >{{
                      $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.editar")
                    }}</span
                  >
                </p>

                <b-collapse
                  class="datos"
                  id="proforma"
                  accordion="accordion-perfil"
                  role="tabpanel"
                >
                  <div class="row form-grupo">
                    <div class="col-12">
                      <label class="m-0 radio" for="noEnviarProforma">
                        <input
                          type="radio"
                          id="noEnviarProforma"
                          class="hidden"
                          value="false"
                          v-model="proforma"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.noEnviarProforma"
                          )
                        }}</span>
                      </label>
                    </div>
                    <div class="col-12">
                      <label class="m-0 radio" for="enviarProforma">
                        <input
                          type="radio"
                          id="enviarProforma"
                          class="hidden"
                          value="true"
                          v-model="proforma"
                        />
                        <span class="label"></span
                        ><span>{{
                          $t(
                            "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.enviarProforma"
                          )
                        }}</span>
                      </label>
                      <div class="row" v-if="proforma == 'true'">
                        <div class="col-12 col-lg-4">
                          <div class="form-element">
                            <label for=""
                              >{{
                                $t(
                                  "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.email"
                                )
                              }}
                              1*</label
                            >
                            <input
                              type="text"
                              :placeholder="
                                $t(
                                  'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ejemplo'
                                ) +
                                  '@' +
                                  $t(
                                    'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.correo'
                                  ) +
                                  '.com'
                              "
                              v-model="configPerfil.mailProforma1"
                              v-email
                              :class="{ 'is-invalid': !$v.configPerfil.mailProforma1.email }"
                            />
                            <span class="notas" v-if="!$v.configPerfil.mailProforma1.email">{{
                              $t(
                                "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.emailInvalid"
                              )
                            }}</span>
                          </div>

                          <div class="form-element">
                            <label for=""
                              >{{
                                $t(
                                  "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.email"
                                )
                              }}
                              2</label
                            >
                            <input
                              type="text"
                              :placeholder="
                                $t(
                                  'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ejemplo'
                                ) +
                                  '@' +
                                  $t(
                                    'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.correo'
                                  ) +
                                  '.com'
                              "
                              v-model="configPerfil.mailProforma2"
                              v-email
                              :class="{ 'is-invalid': !$v.configPerfil.mailProforma2.email }"
                            />
                            <span class="notas" v-if="!$v.configPerfil.mailProforma2.email">{{
                              $t(
                                "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.emailInvalid"
                              )
                            }}</span>
                          </div>

                          <div class="form-element">
                            <label for=""
                              >{{
                                $t(
                                  "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.email"
                                )
                              }}
                              3</label
                            >
                            <input
                              type="text"
                              :placeholder="
                                $t(
                                  'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ejemplo'
                                ) +
                                  '@' +
                                  $t(
                                    'language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.correo'
                                  ) +
                                  '.com'
                              "
                              v-model="configPerfil.mailProforma3"
                              v-email
                              :class="{ 'is-invalid': !$v.configPerfil.mailProforma3.email }"
                            />
                            <span class="notas" v-if="!$v.configPerfil.mailProforma3.email">{{
                              $t(
                                "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.emailInvalid"
                              )
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>

          <Loader v-if="banLoaderCU"/>
          <!-- Botones -->
          <div class="row ">
            <div class="col-12 col-lg-4 botonesInfo order-2 order-lg-1">
              <button @click="reset()" class="secondary-button">
                {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.cancelar") }}
              </button>
            </div>
            <div class="col-12 col-lg-5 col-xl-4 botonesInfo order-1 order-lg-2 mb-2 mb-lg-0">
              <button
                v-if="!enableEditOptions"
                class="button"
                @click="crearUsuarioForm"
                :disabled="isDisabledFormulario || banLoaderCU"
              >
                {{ titleNuevoUsuario }}
              </button>
              <button
                v-if="enableEditOptions"
                class="button"
                @click="crearUsuarioForm"
                :disabled="isDisabledFormularioEdition || banLoaderCU"
              >
                {{ titleNuevoUsuario }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal PASS IS NO EQUAL -->
    <modal v-show="isModalPass" @close="closeModalNotSamePass" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t("language.posadasCorporate.modales.verifyPass.title") }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t("language.posadasCorporate.modales.verifyPass.body") }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalNotSamePass()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.modales.verifyPass.entendido") }}
        </button>
      </template>
    </modal>

    <!-- Modal Guardar/modificar -->

    <!-- Modal Usuario duplicado -->
    <modal v-if="isModalDuplicado" @close="closeModalDuplicado" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalUsuarioUso.usuUso") }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalUsuarioUso.body1") }}
          {{ realUserName }}
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalUsuarioUso.body2") }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalDuplicado()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalUsuarioUso.entendido") }}
        </button>
      </template>
    </modal>

    <!-- Modal Guardar/modificar -->
    <modal v-show="isModalUsuarioNuevo" @close="closeModalUsuario" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ modalTitle }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ ModalBody }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalUsuario()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.entendido") }}
        </button>
      </template>
    </modal>

    <!-- Modal Eliminar -->
    <modal v-show="isModalEliminar" @close="closeModalEliminar" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalEliminar.eliPerfilUsu") }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalEliminar.body") }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button secondary-button order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalEliminar()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalEliminar.cancelar") }}
        </button>
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="showModalHeredar(), (isModalConfirmacionEliminar = true)"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalEliminar.eliPerfil") }}
        </button>
      </template>
    </modal>

    <!-- Modal Heredar -->
    <modal v-if="isModalHeredar" @close="closeModalHeredar" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="caution mt-2 pt-3">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{
            $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.heredarPermUsuEli")
          }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.body1") }}
        </p>
        <p class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.body2") }}
        </p>
        <p class="Ta-left">
          <label for="heredar" style="width: 100%;">
            <span class="b m-0" style="float: left;">{{
              $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.nomUsuHeredar")
            }}</span>
            <input
              type="text"
              maxlength="20"
              v-model="usuarioHeredar"
              :placeholder="
                $t('language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.ejemplo') +
                  ': administrador.corporate'
              "
            />
          </label>
        </p>
        <Loader v-if="banLoaderHeredar" />
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button secondary-button order-1 order-lg-2 botonesSoloadultos"
          :disabled="banLoaderHeredar"
          @click="showModalHeredado(1), (heredar = false)"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.noHeredarPerm") }}
        </button>
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          :disabled="
            usuarioHeredar == '' ||
              banLoaderHeredar ||
              usuarioHeredar.length < 3 ||
              !validRegex.test(usuarioHeredar)
          "
          @click="showModalHeredado(2), (isModalConfirmacionHeredar = true), (heredar = true)"
          aria-label="Close modal"
        >
          {{
            $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.heredarPermisos")
          }}
        </button>
      </template>
    </modal>

    <!-- Modal confirmación de heredado -->
    <modal v-if="isModalHeredado" @close="closeModalHeredado" maxWidth="max-w-500">
      <template slot="header">
        <b v-if="heredar" class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{
            $t(
              "language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.permisosHeredadosExito"
            )
          }}
        </b>
        <b v-else class="verde mt-2 pt-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.body3") }}
        </b>
      </template>
      <template slot="body">
        <p v-if="heredar" class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.text12") }}
          {{ selectDelete }}
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.text22") }}
        </p>
        <p v-else class="Ta-left">
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.body4_1") }}
          {{ selectDelete }}
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.body4_2") }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalHeredado()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalHeredar.entendido") }}
        </button>
      </template>
    </modal>

    <!-- Modal service error -->
    <modal v-if="isModalError" @close="closeModalError" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{
            $t(
              "language.posadasCorporate.tablaUsuariosRegistrados.modalServiceError.usuarioNoExiste"
            )
          }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ bodyModalServiceError }}
        </p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalError()"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.tablaUsuariosRegistrados.modalServiceError.entendido") }}
        </button>
      </template>
    </modal>

    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t("language.posadasCorporate.modales.expiredSession.title") }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t("language.posadasCorporate.modales.expiredSession.body") }}</p>
      </template>
      <template slot="footer">
        <button
          type="button"
          class="button btn-primary"
          @click="closeExpiredModal"
          aria-label="Close modal"
        >
          {{ $t("language.posadasCorporate.modales.expiredSession.button") }}
        </button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->
  </div>
</template>

<script>
import Mixin from "../../../mixins/commons.js";
import axios from "axios";
import Modal from "./../../addons/Modal.vue";
import i18n from "../../../plugins/i18n";
import SecureLS from "secure-ls";
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import * as GlobalServices from "../../../utils/GlobalServices";
import Loader from "../../loader/Loader";

import { required, email, sameAs } from "vuelidate/lib/validators";
export default {
  name: "TablaAdministracionUsuarios",
  components: {
    Modal,
    Loader
  },
  mixins: [Mixin],
  mounted() {
    if (!GlobalFunctions.validIfGenericUser()) {
      if (
        this.ls.get("Profile").data.userType == "ADMIN" ||
        this.ls.get("Profile").data.userType == "SUPER_ADMIN"
      ) {
        this.noOptions = true;
        this.dataTable();
      } else {
        this.noOptions = false;
      }
      this.$nextTick(function() {
        window.addEventListener("resize", this.getWindowWidth);
        this.getWindowWidth();
      });
    }
  },
  created() {
    if (!GlobalFunctions.validIfGenericUser()) {
      this.getUserDetailSesssion(this.ls.get("Profile").data.username, true);
      this.chargeProfiles();
      this.chargeCountries();
      let userType = this.ls.get("Profile").data.userType;
      if (userType == "AGENTE" && userType != "" && userType != null) {
        this.enableUser = false;
      } else {
        this.enableUser = true;
      }
      this.userTypeP = this.ls.get("Profile").data.userType;
      this.nu001(userType); 
    }
  },
  data: () => {
    return {
      idPropertyAgenteGenerico: '139', //no cambiar este valor
      idPropertyProforma: '138', //no cambiar este valor
      idPropertyAgente: '102', //no cambiar este valor
      mayCreateUserGeneric: false,
      mayCreateAgent: false,
      mayAsignUserGeneric: false,
      selectedUser: 'AGENTE',
      banLoaderCU: false,
      banSelectedPais: false,
      rowsNumber: 0,
      realUserNamePass: true,
      filtroUsuarioDado: "",
      realAddress: "",
      realTown: "",
      validateFormRepeatedUser: false,
      realZip: "",
      realCity: "",
      repeatedUserModal: false,
      repeatedUser: "",
      createModule: true,
      initSessionProperties: [],
      mailContacto: "",
      mailContactoConfirm: "",
      realNumeroCentro: "",
      realNumeroApreciare: "",
      realNumeroFiesta: "",
      realLastName: "",
      realLastName2: "",
      realUserName: "",
      realFirstName: "",
      LastName: "",
      LastName2: "",
      validRegex: /^[a-zA-Z\\d\\.\\1-9\\0\\ ]*$/,
      validRegexNoNumbers: /^[a-zA-Z\\d\\.\\ ]*$/,
      validRegexComma: /^[a-zA-Z\\d\\.\\1-9\\0\\ \\,]*$/,
      validRegexEMPLE: /^[a-zA-Z0-9-_\\ ]+$/,
      validRegexFR: /^[a-zA-Z0-9-_]+$/,
      realNumeroEmple: "",
      editValidation: false,
      originalPassword: "",
      enableLoader: false,
      pickedTelelefonoUf: "",
      officeNumber: "",
      homeNumber: "",
      cellNumber: "",
      filterSearch: "",
      temporaryTable: false,
      changeUnableMessage: "",
      contactsAcord: false,
      contrasenaConfirma: "",
      contrasenaUsuario: "",
      realCountry: "",
      isModalError: false,
      bodyModalServiceError: "",
      banLoaderHeredar: false,
      enablePoliciesForAdmin: true,
      showPublicRatesValue: false,
      showRatesValue: false,
      detailSessionUser: null,
      adminShowPublic: true,
      adminRates: true,
      enableProforma: true,
      modifyUsers: false,
      time2: true,
      time1: true,
      credit2: true,
      credit1: true,
      voucher2: true,
      voucher1: true,
      userTypeP: "",
      policiesS: [],
      superAdProperties: [],
      givenProfile: "",
      profilesAutocomplete: null,
      creditType: [],
      verTarifasNeg: false,
      verDispo: false,
      userNameD: "",
      userCommonName: "",
      numEmpD: "",
      emailD: "",
      typeUserD: "",
      activeUserD: "",
      propertiesListD: [],
      policiesD: [],
      hidePolicies: true,
      detailUser: null,
      userProperties: [],
      isModalPass: false,
      allUsers: [],
      noMoreUsers: false,
      enableAgent: false,
      enableAdmin: false,
      enableEditOptions: false,
      enableUser: false,
      codeCountry: "",
      codeState: "",
      device: "desktop",
      // Paginador
      currentPagePols: 1,
      perPagePols: 12,
      emailMatch: true,
      passwordMatch: true,
      passwordNot10M: true,
      passwordNot10: true,
      isExpiredModalVisible: false,
      noOptions: false,
      ls: new SecureLS({ encodingType: "aes" }),
      passwordFieldType: "password",
      passwordFieldTypeConfirm: "password",
      openEye: "__eyeIcon",
      closeEye: "__closeEyeIcon",
      openEyeConfirm: "__eyeIcon",
      closeEyeConfirm: "__closeEyeIcon",
      isModalDuplicado: false,
      isModalUsuarioNuevo: false,
      isModalEliminar: false,
      isModalHeredar: false,
      heredar: true,
      isModalHeredado: false,
      usuarioHeredar: "",
      modalTitle: "",
      ModalBody: "",
      showDetalle: false,
      showEditar: false,
      showUsuario: false,
      actionUsuario: "",
      visible: true,
      datosGeneralesPasos: true,
      datosGeneralesForm: true,
      datosConfigForm: false,
      perPage: 7,
      totalRows: 1,
      currentPage: 1,
      selectDelete: "",
      titleNuevoUsuario: i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.crearNuevoUsuario"
      ),
      titleBtnContraseña: i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contContrasena"
      ),
      titleTitleContraseña: i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contrasenaReg"
      ),
      filters: {
        name: ""
      },
      fields: [
        {
          key: "userName",
          stickyColumn: true,
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.usuario")
        },
        {
          key: "name",
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.nombre")
        },
        {
          key: "lastName",
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.apellido")
        },
        {
          key: "into",
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.ultimoIngreso")
        },
        {
          key: "status",
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.status")
        },
        {
          key: "options",
          label: i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.table.opciones")
        }
      ],
      items: [],
      filter: null,
      filterOn: [],
      picked: "",
      checkedUser: "admin",
      voucher: "Ninguno",
      credito: "Ninguno",
      tdc: "Ninguno",
      token: "Ninguno",
      limite: "Ninguno",
      proforma: "noEnviarProforma",
      configPerfil: {
        iconoActivo: 0,
        datosTipoUsuario: true,
        datosAdmin: false,
        datosAgente: false,
        datosMetodoPago: true,
        datosTarifasPoliticas: true,
        datosProforma: true,
        mailProforma1: "",
        mailProforma2: "",
        mailProforma3: "",
        // Perfil existente
        showPerfiles: false,
        buscador: false,
        search: "",
        perfiles: []
      },
      infoPersonal: {
        //Activador de Icono
        iconoHabitacion: 0,
        iconoActivo: 0,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        contrasena: true,
        datosProforma: true,
        datosRequerimientos: true,
        // Perfiles
        perfil: false,
        perfilDado: "",
        perfiles: [],
        // Filtrar
        filtroUsuario: false,
        filtroUsuarioDado: "",
        filtroUsuarios: [
          {
            nombre: "A"
          },
          {
            nombre: "B"
          },
          {
            nombre: "C"
          },
          {
            nombre: "D"
          },
          {
            nombre: "E"
          },
          {
            nombre: "F"
          },
          {
            nombre: "G"
          },
          {
            nombre: "H"
          },
          {
            nombre: "I"
          },
          {
            nombre: "J"
          },
          {
            nombre: "K"
          },
          {
            nombre: "L"
          },
          {
            nombre: "M"
          },
          {
            nombre: "N"
          },
          {
            nombre: "Ñ"
          },
          {
            nombre: "O"
          },
          {
            nombre: "P"
          },
          {
            nombre: "Q"
          },
          {
            nombre: "R"
          },
          {
            nombre: "S"
          },
          {
            nombre: "T"
          },
          {
            nombre: "U"
          },
          {
            nombre: "V"
          },
          {
            nombre: "W"
          },
          {
            nombre: "X"
          },
          {
            nombre: "Y"
          },
          {
            nombre: "Z"
          }
        ],
        nombreUsuario: "",
        // Nombre
        nombres: "",
        apellidoP: "",
        apellidoM: "",
        // Numeros
        numEmp: "",
        numFiesta: "",
        numApreciare: "",
        numCentro: "",
        pickedTelelefono: "",
        numTelefonico: "",
        // tipos de direccion
        pickedDireccion: "",
        direccion: "",
        colonia: "",
        codigoPostal: "",
        mailContacto: "",
        mailContactoCopia: "",
        mailContactoConfirmacion: "",
        //paises
        pais: false,
        paisSeleccionado: "",
        paises: [
          {
            nombre: "México"
          },
          {
            nombre: "EEUU"
          },
          {
            nombre: "Canada"
          },
          {
            nombre: "Colombia"
          },
          {
            nombre: "España"
          }
        ],
        //estados
        estado: false,
        estadoSeleccionado: "",
        estados: [],
        ciudad: "",
        contrasenaUsuario: "",
        contrasenaConfirma: "",
        desHabilitarUsuario: false,
        showExtraTypeMobile: false
      }
    };
  },
  validations: {
    mailContacto: {
      required,
      email
    },
    mailContactoConfirm: {
      required,
      email
    },
    configPerfil: {
      mailProforma1: {
        required,
        email
      },
      mailProforma2: {
        required,
        email
      },
      mailProforma3: {
        required,
        email
      }
    },
    infoPersonal: {
      mailContacto: {
        required,
        email
      },
      mailContactoCopia: {
        required,
        email
      },
      mailContactoConfirmacion: {
        required,
        email
      }
    }
  },
  watch: {
    selectedUser(){
      this.modifyUsers = false;
    },
    proforma() {
        if(this.proforma !== 'true') {
              this.configPerfil.mailProforma1 = ''
        } else {

        }
    },
    filtroUsuarioDado() {
      if (this.filtroUsuarioDado != "" && this.filtroUsuarioDado != null) {
        this.currentPage = 1;
      }
    },
    realAddress() {
      let str = "";
      if (!this.validRegexComma.test(this.realAddress)) {
        str = this.realAddress.substring(0, this.realAddress.length - 1);
        this.realAddress = str;
      }
    },
    realTown() {
      let str = "";
      if (!this.validRegexComma.test(this.realTown)) {
        str = this.realTown.substring(0, this.realTown.length - 1);
        this.realTown = str;
      }
    },
    realCity() {
      let str = "";
      if (!this.validRegexComma.test(this.realCity)) {
        str = this.realCity.substring(0, this.realCity.length - 1);
        this.realCity = str;
      }
    },
    mailContacto() {
      if (this.mailContactoConfirm != "") {
        if (this.mailContactoConfirm == this.mailContacto) {
          this.emailMatch = true;
        } else {
          this.emailMatch = false;
        }
      }
      if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true;
      }
    },
    mailContactoConfirm() {
      if (this.mailContactoConfirm == this.mailContacto) {
        this.emailMatch = true;
      } else {
        this.emailMatch = false;
      }
      if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true;
      }
    },
    realZip() {
      let str = "";
      if (!this.validRegex.test(this.realZip)) {
        str = this.realZip.substring(0, this.realZip.length - 1);
        this.realZip = str;
      }
    },
    realNumeroCentro() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroCentro)) {
        str = this.realNumeroCentro.substring(0, this.realNumeroCentro.length - 1);
        this.realNumeroCentro = str;
      }
    },
    realNumeroApreciare() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroApreciare)) {
        str = this.realNumeroApreciare.substring(0, this.realNumeroApreciare.length - 1);
        this.realNumeroApreciare = str;
      }
    },
    realNumeroFiesta() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroFiesta)) {
        str = this.realNumeroFiesta.substring(0, this.realNumeroFiesta.length - 1);
        this.realNumeroFiesta = str;
      }
    },
    realNumeroEmple() {
      let str = "";
      if (!this.validRegexEMPLE.test(this.realNumeroEmple)) {
        str = this.realNumeroEmple.substring(0, this.realNumeroEmple.length - 1);
        this.realNumeroEmple = str;
      }
    },
    realLastName() {
      let str = "";
      if (!this.validRegexNoNumbers.test(this.realLastName)) {
        str = this.realLastName.substring(0, this.realLastName.length - 1);
        this.realLastName = str;
      }
    },
    realLastName2() {
      let str = "";
      if (!this.validRegexNoNumbers.test(this.realLastName2)) {
        str = this.realLastName2.substring(0, this.realLastName2.length - 1);
        this.realLastName2 = str;
      }
    },
    realFirstName() {
      let str = "";
      if (!this.validRegexNoNumbers.test(this.realFirstName)) {
        str = this.realFirstName.substring(0, this.realFirstName.length - 1);
        this.realFirstName = str;
      }
    },
    realUserName() {
      let str = "";
      this.validateUserForm();
      if (!this.validRegex.test(this.realUserName)) {
        str = this.realUserName.substring(0, this.realUserName.length - 1);
        this.realUserName = str;
      }
      if (
        this.repeatedUser == this.realUserName &&
        this.realUserName != "" &&
        this.repeatedUser != ""
      ) {
        this.repeatedUserModal = true;
      } else {
        this.repeatedUserModal = false;
      }
    },
    usuarioHeredar() {
      let str = "";
      if (!this.validRegex.test(this.usuarioHeredar)) {
        str = this.usuarioHeredar.substring(0, this.usuarioHeredar.length - 1);
        this.usuarioHeredar = str;
      }
    },
    enableEditOptions() {
      if (this.enableEditOptions) {
        if (this.contrasenaUsuario == "") {
          this.editValidation = true;
        }
      } 
    },
    pickedTelelefonoUf() {
      switch (this.pickedTelelefonoUf) {
        case "MOB":
          if(this.cellNumber !== "") {
            this.infoPersonal.numTelefonico = this.cellNumber;
          }
          break;
        case "HOM":
          if(this.homeNumber !== "") {
            this.infoPersonal.numTelefonico = this.homeNumber;
          }
          break;
        case "BUS":
          if(this.officeNumber !== "") {
            this.infoPersonal.numTelefonico = this.officeNumber;
          }
          break;
        default:
          break;
      }
    },
    filterSearch() {
      if (this.filterSearch != "" && this.filterSearch != null) {
        this.currentPage = 1;
      }
    },
    activeUserD() {
      if (this.detailUser.active) {
      } else {
        if (this.$store.getters.gettingLang == "es") {
          this.changeUnableMessage =
            "Volver a habilitar a este usuario para que pueda utilizar el sistema";
        } else {
          this.changeUnableMessage = "Re-enable this user to use the system";
        }
      }
    },
    contrasenaConfirma() {
      if (this.contrasenaConfirma.length < 10) {
        this.passwordNot10 = false;
      } else {
        this.passwordNot10 = true;
      }

      if (
        (this.contrasenaUsuario == "" ||
          (this.contrasenaUsuario.length > 9 &&
            this.contrasenaConfirma.length > 9 &&
            this.passwordMatch)) &&
        this.enableEditOptions
      ) {
        this.editValidation = true;
      } else {
        this.editValidation = false;
      }
    },
    contrasenaUsuario() {
      if (this.contrasenaUsuario.length < 10) {
        this.passwordNot10M = false;
      } else {
        this.passwordNot10M = true;
      }
      if (
        (this.contrasenaUsuario == "" ||
          (this.contrasenaUsuario.length > 9 &&
            this.contrasenaConfirma.length > 9 &&
            this.passwordMatch)) &&
        this.enableEditOptions
      ) {
        this.editValidation = true;
      } else {
        this.editValidation = false;
      }

    },
    codeCountry() {
      if (this.codeCountry != "") {
        for (var x = 0; x < this.infoPersonal.paises.length; x++) {
          if (this.codeCountry == this.infoPersonal.paises[x].countryCode) {
            this.realCountry = this.infoPersonal.paises[x].nombre;
            this.banSelectedPais = true;
            this.cambiaPais(this.realCountry)
          }
        }
      }
    },
    givenProfile() {
      if (this.givenProfile != "") {
        this.autoProfile();
      }
    },
    passwordMatch() {
      if (!this.passwordMatch) {
        this.isModalPass = true;
      }
      if (
        (this.contrasenaUsuario == "" ||
          (this.contrasenaUsuario.length > 9 &&
            this.contrasenaConfirma.length > 9 &&
            this.passwordMatch)) &&
        this.enableEditOptions
      ) {
        this.editValidation = true;
      } else {
        this.editValidation = false;
      }
    },
    codeState() {
      if (this.codeState != "") {
        for (var x = 0; x < this.infoPersonal.estados.length; x++) {
          if (this.codeState == this.infoPersonal.estados[x].nombre) {
            this.codeState = this.infoPersonal.estados[x].code;
          }
        }
      }
    }
  },
  methods: {
    tsss(){
      this.policiesS = [];
      this.infoPersonal.desHabilitarUsuario = false;
      this.codeCountry = '';
      this.realCountry = '';
      this.infoPersonal.estadoSeleccionado = '';
      this.codeState = '';
      this.resetSelectedPais();
    },
    resetSelectedPais(){
      this.banSelectedPais = false;
      this.infoPersonal.estadoSeleccionado = '';
    },
    outsidePass() {
      if (this.contrasenaConfirma != "") {
        if (this.contrasenaConfirma != this.contrasenaUsuario) {
          this.isModalPass = true;
          this.passwordMatch = false;
        } else {
          this.isModalPass = false;
          this.passwordMatch = true;
        }
      }
    },
    updateValue(event) {
      const value = event.target.value;
      if (String(value).length <= 10) {
        this.infoPersonal.numTelefonicoOficina = value;
      }
      this.$forceUpdate();
    },
    outsideSearch(e) {
      this.infoPersonal.perfil = false;
    },
    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },
    closeModalError() {
      this.isModalError = false;
      this.limpiarData();
    },
    delUser() {
      var data = {
        newUser: this.usuarioHeredar,
        userId: this.selectDelete 
      };
      GlobalServices._deleteUser(this.ls.get("Token").data, this.ls.get("Language").data, data)
        .then(response => {
          if (response.status == 200) {
            this.banLoaderHeredar = false;
            this.isModalHeredar = false;
            this.dataTable();
            this.isModalHeredado = true;
          }
        })
        .catch(error => {
          if (error.status === 404 && error.errorCode == "RSP_USER06") {
            this.isModalHeredar = false;
            this.bodyModalServiceError = error.data.message;
            this.isModalError = true;
          }
          this.controlOfErrors(error);
        });
    },
    controlOfErrors(error) {
      if (error.status == 401) {
        this.sesionClose();
      }
      let errorObject = JSON.parse(JSON.stringify(error));
      if (
        errorObject.message == "Network Error" ||
        (error.response.status < 600 && error.response.status > 403) ||
        (error.response.status < 399 && error.response.status > 299) ||
        error.response.status < 200
      ) {
        this.$router.push({ name: "Error" });
      }
    },
    sesionClose() {
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    checkPolicyRightForAdmin() {
      var userHasNoPoliciesRights = false;
      for (var i = 0; i < this.detailUser.properties; i++) {
        if (this.detailUser.properties[i].propertieId == "121") {
          userHasNoPoliciesRights = true;
        }
      }

      if (
        this.enableEditOptions &&
        this.detailUser.userType == "ADMIN" &&
        this.policiesS.length == 0 &&
        !userHasNoPoliciesRights
      ) {
        this.enablePoliciesForAdmin = false;
      }
    },
    editUserW() {
      var isTrueSet = this.proforma === "true";
      var emails = [];
      if (this.configPerfil.mailProforma1 != "" && this.configPerfil.mailProforma1 != null) {
        emails.push(this.configPerfil.mailProforma1);
      }
      if (this.configPerfil.mailProforma2 != "" && this.configPerfil.mailProforma2 != null) {
        emails.push(this.configPerfil.mailProforma2);
      }
      if (this.configPerfil.mailProforma3 != "" && this.configPerfil.mailProforma3 != null) {
        emails.push(this.configPerfil.mailProforma3);
      }

      // Get selected policies
      var selectedPolicies = [];
      for (var i = 0; i < this.policiesS.length; i++) {
        if (this.policiesS[i].value) {
          selectedPolicies.push({
            id: Number(this.policiesS[i].travelPolicyId),
            priority: Number(this.policiesS[i].policyPriority)
          });
        }
      }
      //    Get selected propertiesIdList
      var selectedProperties = [];
      for (var i = 0; i < this.superAdProperties.length; i++) {
        if (this.superAdProperties[i].value) {
          selectedProperties.push(Number(this.superAdProperties[i].propertieId));
        }
      }
      if (this.voucher != null && this.voucher != "" && this.voucher != "Ninguno") {
        selectedProperties.push(Number(this.voucher));
      }
      if (this.credito != null && this.credito != "" && this.credito != "Ninguno") {
        selectedProperties.push(Number(this.credito));
      }
      if (this.limite != null && this.limite != "" && this.limite != "Ninguno") {
        selectedProperties.push(Number(this.limite));
      }
      // Difine userType
      var userTypeR = "";
      var nagarada = "";
      if (this.userTypeP == "SUPER_ADMIN") {
        userTypeR = "ADMIN";
      } else 
      //  Edition specifics
      if (this.detailUser.userType == "ADMIN" || this.userTypeP == "ADMIN") {
        if (this.mayCreateUserGeneric && this.selectedUser == 'AGENTE_GENERICO') {
          userTypeR = "AGENTE";
          nagarada = "AGENTE Web Site GENERICO";          
        } else {
          userTypeR = "AGENTE";
          nagarada = "AGENTE Web Site";
        }
      } else if (this.detailUser.userType == "AGENTE") {
        nagarada = "AGENTE Web Site";
      }
      //
      if (this.contrasenaUsuario == "" && this.originalPassword != "") {
        this.contrasenaUsuario = this.originalPassword;
      }
      if(this.enableAgent) {
        if(this.modifyUsers && !selectedProperties.includes("132") && !selectedProperties.includes(132)) {
          selectedProperties.push("132")
        } else if(!this.modifyUsers) {
          const no132 = selectedProperties.filter((element) => element != "132")
          selectedProperties = no132
        }

        if (this.mayCreateUserGeneric && this.selectedUser == 'AGENTE_GENERICO') {
          selectedProperties.push(this.idPropertyAgenteGenerico);
        }
      }

      if (this.configPerfil.mailProforma1 != '' || this.configPerfil.mailProforma2 != '' || this.configPerfil.mailProforma3 != '') {
        selectedProperties.push(this.idPropertyProforma);
      }
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_UPDATEUSER,
          {
            addres: this.realAddress.toUpperCase(),
            addres2: this.realTown.toUpperCase(),
            centroCostos: this.realNumeroCentro.toUpperCase(),
            cityName: this.realCity.toUpperCase(),
            codigoPostal: this.realZip.toUpperCase(),
            countryCode: this.codeCountry,
            creditStatus: this.ls.get("Profile").data.creditStatus, // ?
            deactivated: this.detailUser.active
              ? !this.infoPersonal.desHabilitarUsuario
              : this.infoPersonal.desHabilitarUsuario,
            email: this.mailContacto,
            email2: this.infoPersonal.mailContactoConfirmacion,
            emailsProform: emails,
            empleadoNumber: this.realNumeroEmple.toUpperCase(),
            excellentClubPin: this.realNumeroApreciare.toUpperCase(),
            fiestaRewarsNumber: this.realNumeroFiesta.toUpperCase(),
            fiestaRewarsPin: "",
            firstName: this.realFirstName.toUpperCase(),
            lastName: this.realLastName.toUpperCase(),
            middleName: "",
            motherMaidenName: this.realLastName2 != null ? this.realLastName2.toUpperCase() : "",
            numberPhone: this.infoPersonal.numTelefonico,
            numberType: this.pickedTelelefonoUf,
            password: this.contrasenaUsuario,
            policies: selectedPolicies,
            profileIdNumber: this.detailUser.profile.profileId,
            propertiesIdList: selectedProperties,
            recibeNewsLetter: 0,
            showC2K: this.detailUser.showC2K,
            showFR: this.detailUser.showFR,
            showINT: this.detailUser.showINT,
            showPIF: this.detailUser.showPIF,
            showPublicRates: this.showPublicRatesValue, 
            showRates: this.showRatesValue,
            stateCode: this.codeState,
            tipoPerfil: "",
            userId: this.detailUser.userId,
            userType: this.detailUser.userType,
            userTypeDescription: nagarada
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.banLoaderCU = false;
          this.contrasenaUsuario = "";
          this.showModalUsuario();
          this.reset();
          this.tsss();
        })
        .catch(error => {
          this.banLoaderCU = false;
          this.contrasenaUsuario = "";
          this.reset();

          let errorObject = JSON.parse(JSON.stringify(error));
          if (
            errorObject.message == "Network Error" ||
            (error.response.status < 600 && error.response.status > 403) ||
            (error.response.status < 399 && error.response.status > 299) ||
            error.response.status < 200
          ) {
            this.$router.push({ name: "Error" });
          } 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } 
        });
    },
    resetConfigEdition() {
      if (this.policiesS != null && this.policiesS.length != 0) {
        for (var i = 0; i < this.policiesS.length; i++) {
          this.policiesS[i].value = false;
        }
      }
      if (this.superAdProperties != null && this.superAdProperties.length != 0) {
        for (var i = 0; i < this.superAdProperties.length; i++) {
          this.superAdProperties[i].value = false;
        }
      }
      this.modifyUsers = false;
      this.voucher = "Ninguno";
      this.credito = "Ninguno";
      this.limite = "Ninguno";
      this.showRatesValue = false;
      this.showPublicRatesValue = false;
      this.proforma = "false";
      this.configPerfil.mailProforma1 = "";
      this.configPerfil.mailProforma2 = "";
      this.configPerfil.mailProforma3 = "";
      this.passwordNot10M = true
      this.passwordNot10 = true
			this.passwordMatch = true
    },
    goConfigUser() {
      if (this.enableEditOptions) {
        // Get properties from chosen list user FOR AGENTS
        for (var j = 0; j < this.detailUser.properties.length; j++) {
          if ("132" == this.detailUser.properties[j].propertieId) {
            this.modifyUsers = true;
          }
        }
        // Get properties from chosen list user
        for (var i = 0; i < this.superAdProperties.length; i++) {
          for (var j = 0; j < this.detailUser.properties.length; j++) {
            if (
              this.superAdProperties[i].propertieId == this.detailUser.properties[j].propertieId
            ) {
              this.superAdProperties[i].value = true;
            }
          }
        }
        // Get payment methods from chosen list user
        this.voucher = "Ninguno";
        this.credito = "Ninguno";
        this.limite = "Ninguno";
        for (var j = 0; j < this.detailUser.properties.length; j++) {
          switch (this.detailUser.properties[j].propertieId) {
            case "125":
            case "124":
              this.voucher = this.detailUser.properties[j].propertieId;
              break;
            case "118":
            case "117":
              this.credito = this.detailUser.properties[j].propertieId;
              break;
            case "119":
            case "120":
              this.limite = this.detailUser.properties[j].propertieId;
              break;
            default:
              break;
          }
        }
        // Get rates from chosen list user
        if (this.detailUser.showRates) {
          this.showRatesValue = true;
        } else {
          this.showRatesValue = false;
        }
        if (this.detailUser.showPublicRates) {
          this.showPublicRatesValue = true;
        } else {
          this.showPublicRatesValue = false;
        }
        this.proforma =
          this.detailUser.emailProform.length != 0 && this.detailUser.emailProform != null
            ? "true"
            : "false";
        this.configPerfil.mailProforma1 =
          this.detailUser.emailProform[0] != null ? this.detailUser.emailProform[0] : "";
        this.configPerfil.mailProforma2 =
          this.detailUser.emailProform[1] != null ? this.detailUser.emailProform[1] : "";
        this.configPerfil.mailProforma3 =
          this.detailUser.emailProform[2] != null ? this.detailUser.emailProform[2] : "";

      }
    },
    adminProperties(properties) {
      // Payment methods
      this.time2 = false;
      this.time1 = false;
      this.credit2 = false;
      this.credit1 = false;
      this.voucher2 = false;
      this.voucher1 = false;
      this.adminShowPublic = false;
      this.adminRates = false;
      this.adminShowPublic = properties.showPublicRates;
      this.adminRates = properties.showRates;
      let property = {};
      for (property of properties.properties) {
        switch (property.propertieId) {
          case "125":
            this.voucher1 = true;
            break;
          case "124":
            this.voucher2 = true;
            break;
          case "118":
            this.credit1 = true;
            break;
          case "117":
            this.credit2 = true;
            break;
          case "120":
            this.time1 = true;
            break;
          case "119":
            this.time2 = true;
            break;
          default:
            break;
        }
      }
    },
    getUserDetailSesssion(userId, init) {
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_CONDU,
          {
            userId: userId
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          for (let fff of response.data.response.properties) {
            if (fff.propertieId == this.idPropertyAgenteGenerico) {
              this.mayCreateUserGeneric = true;
            }
            if (fff.propertieId == this.idPropertyAgente) {
              this.mayCreateAgent = true;
            }
          }

          if (!this.mayCreateUserGeneric && this.mayCreateAgent) {
            this.selectedUser = 'AGENTE';
          }

          if (this.mayCreateUserGeneric && !this.mayCreateAgent) {
            this.selectedUser = 'AGENTE_GENERICO';
          }
          // Consultar detalle de usuario
          this.mayAsignUserGeneric = response.data.response.allowGenericUser;
          this.getProperties();
          var listProperties = response.data.response.properties;
          if (!this.enableEditOptions) {
            this.policiesS = response.data.response.profilePolicies;
            var result = this.policiesS.map(function(el) {
              var o = Object.assign({}, el);
              o.value = false;
              return o;
            });
            this.policiesS = result;
          }
          if (
            response.data.response.emailProform != null &&
            response.data.response.emailProform.length == []
          ) {
            this.enableProforma = false;
          } else {
            this.enableProforma = true;
          }
          if (!init) {
            this.detailSessionUser = response.data.response;
            if (this.userTypeP == "ADMIN") {
              this.adminProperties(response.data.response);
            }
          } else {
            this.initSessionProperties = response.data.response.properties;
            let enableCreateModule = false;
            if (this.initSessionProperties != null && this.initSessionProperties.length != 0) {
              for (var i = 0; i < this.initSessionProperties.length; i++) {
                if (this.initSessionProperties[i].propertieId == this.idPropertyAgente || this.initSessionProperties[i].propertieId == this.idPropertyAgenteGenerico) {
                  enableCreateModule = true;
                }
              }
            }
            if (enableCreateModule) {
              this.createModule = true;
            } else {
              this.createModule = false;
            }
          }
        })
        .catch(error => {
          let errorObject = JSON.parse(JSON.stringify(error));
          if (
            errorObject.message == "Network Error" ||
            (error.response.status < 600 && error.response.status > 403) ||
            (error.response.status < 399 && error.response.status > 299) ||
            error.response.status < 200
          ) {
            this.$router.push({ name: "Error" });
          } 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    propertiesForSuperAdmin(properties) {
      var prof = this.ls.get('Profile').data;
      this.superAdProperties = [];
      let property = {};
      for (property of properties) {
        if (
          property.propertieId == "132" ||
          property.propertieId == "102" ||
          property.propertieId == "103" ||
          property.propertieId == "104" ||
          property.propertieId == "106" ||
          property.propertieId == "107" ||
          property.propertieId == "109" ||
          property.propertieId == "108" ||
          property.propertieId == "121" ||
          property.propertieId == "122"
        ) {
          this.superAdProperties.push(property);
        }

        if (prof.userType == 'SUPER_ADMIN' && property.propertieId == this.idPropertyAgenteGenerico && this.mayAsignUserGeneric) {
          this.superAdProperties.push(property);
        }
        
      }
      var result = this.superAdProperties.map(function(el) {
        var o = Object.assign({}, el);
        o.value = false;
        return o;
      });
      this.superAdProperties = result;
    },
    autoCompleteEdition(detailUser) {
      this.realFirstName = detailUser.firstName != null ? detailUser.firstName : "";
      this.realLastName = detailUser.lastName != null ? detailUser.lastName : "";
      this.realLastName2 = detailUser.lastName2 != null ? detailUser.lastName2 : "";
      this.realNumeroEmple =
        detailUser.employId != null ? detailUser.employId : "";
      this.realNumeroFiesta =
        detailUser.profile.fiestaRewardsNumber != null
          ? detailUser.profile.fiestaRewardsNumber
          : "";
      this.realNumeroApreciare =
        detailUser.profile.excellencePin != null ? detailUser.profile.excellencePin : "";
      this.realNumeroCentro =
        detailUser.profile.costCenter != null ? detailUser.profile.costCenter : "";
      this.mailContacto = detailUser.email != null ? detailUser.email : "";
      this.mailContactoConfirm = detailUser.email != null ? detailUser.email : "";

      this.infoPersonal.mailContactoConfirmacion =
        detailUser.profile.email2 != null ? detailUser.profile.email2 : "";
      this.realAddress = detailUser.profile.address != null ? detailUser.profile.address : "";
      this.realTown = detailUser.profile.address2 != null ? detailUser.profile.address2 : "";
      this.realZip = detailUser.profile.codigoPostal != null ? detailUser.profile.codigoPostal : "";
      this.realCity = detailUser.profile.cityName != null ? detailUser.profile.cityName : "";
      this.codeCountry =
        detailUser.profile.countryCode != null ? detailUser.profile.countryCode : "";
      this.codeState = detailUser.profile.stateCode != null ? detailUser.profile.stateCode : "";
      //  PHONE
      this.pickedTelelefonoUf = ""
      this.cellNumber = ""
      this.infoPersonal.numTelefonico = ""
      this.homeNumber = ""
      this.officeNumber = ""

      if (detailUser.phoneNUmbers != null && detailUser.phoneNUmbers.length != 0) {
        for (var i = 0; i < detailUser.phoneNUmbers.length; i++) {
          if (detailUser.phoneNUmbers[i].type == "MOB") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = "MOB";
              this.cellNumber = detailUser.phoneNUmbers[i].number;
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number;
            }
          }
          if (detailUser.phoneNUmbers[i].type == "HOM") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = "HOM";
              this.homeNumber = detailUser.phoneNUmbers[i].number;
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number;
            }
          }
          if (detailUser.phoneNUmbers[i].type == "BUS") {
            if (detailUser.phoneNUmbers[i].number != null) {
              this.pickedTelelefonoUf = "BUS";
              this.officeNumber = detailUser.phoneNUmbers[i].number;
              this.infoPersonal.numTelefonico = detailUser.phoneNUmbers[i].number;
            }
          }
        }
      } 
      // PHONE
      this.originalPassword =
        detailUser.profile.password != null ? detailUser.profile.password : "";
    },
    autoProfile() {
      let profile = {};
      for (profile of this.profilesAutocomplete) {
        if (this.givenProfile == profile.guestProfileId) {
          this.realFirstName = profile.name;
          this.realLastName = profile.fatherSurname;
          this.realLastName2 = profile.motherSurname;
          this.realNumeroEmple = profile.employeeNumber;
          this.realNumeroFiesta = profile.fiestaRewardsNumber;
          this.realNumeroApreciare = profile.apreciareClubNumber;
          this.realNumeroCentro = profile.costCenter;
          this.mailContacto = profile.email;
          this.mailContactoConfirm = profile.email;

          this.infoPersonal.mailContactoConfirmacion =
            profile.emailAlternative != null ? profile.emailAlternative : "";
          this.realAddress = profile.address.streetNameWithNumber;
          this.realTown = profile.address.colony;
          this.realZip = profile.address.zipCode;
          this.realCity = profile.address.locality;
          this.codeCountry = profile.address.country;
          this.codeState = profile.address.state;
             this.pickedTelelefonoUf = ""
      this.cellNumber = ""
      this.infoPersonal.numTelefonico = ""
      this.homeNumber = ""
      this.officeNumber = ""
          if(profile.phone != null && profile.phone.length != 0 ) {
                for(var i = 0; i < profile.phone.length; i++) {
                    if(profile.phone[i].type == "MOB") {
                      if(profile.phone[i].number != null) {
                      this.pickedTelelefonoUf = 'MOB'
                          this.cellNumber = profile.phone[i].number
                          this.infoPersonal.numTelefonico = profile.phone[i].number
                      }
                    }
                    if(profile.phone[i].type == "HOM") {
                      if(profile.phone[i].number != null) {
                      this.pickedTelelefonoUf = 'HOM'
                      this.homeNumber = profile.phone[i].number
                      this.infoPersonal.numTelefonico = profile.phone[i].number
                      }
                    }
                    if(profile.phone[i].type == "BUS") {
                      if(profile.phone[i].number != null) {
                      this.pickedTelelefonoUf = 'BUS'
                      this.officeNumber = profile.phone[i].number
                      this.infoPersonal.numTelefonico = profile.phone[i].number
                      }
                    }
					}
					}
      
        }
      }
    },
    goDetailUser(user) {
      this.getUserDetail(user.item.userName, true, true);
    },
    enablePolicies() {
      var rightToPolicy = false;
      if (this.detailUser.properties != null && this.detailUser.properties != []) {
        let policy = {};
        for (policy of this.detailUser.properties) {
          if (policy.propertieId == 121) {
            rightToPolicy = true;
          }
        }
      }

      if (
        this.detailUser.userType == "ADMIN" &&
        (this.policiesS == null || this.policiesS.length == []) &&
        !rightToPolicy
      ) {
        this.hidePolicies = false;
      } else {
        this.hidePolicies = true;
      }
    },
    closeModalNotSamePass() {
      this.isModalPass = false;
    },
    clearForm() {
      this.mailContactoConfirm = "";
      this.mailContacto = "";
      this.cellNumber = "";
      this.homeNumber = "";
      this.officeNumber = "";
      this.realUserName = "";
    },
    validateUser() {
      let user = {};
      this.repeatedUserModal = false;
      for (user of this.allUsers) {
        if (user.userId == this.realUserName && !this.enableEditOptions) {
          this.repeatedUserModal = true;
          this.repeatedUser = user.userId;
          this.showModalDuplicado();
        }
      }
      if (this.isModalDuplicado) {
        this.contactsAcord = false;
        this.visible = true;
        this.infoPersonal.datosPersonales = true; 
      } else {
        this.infoPersonal.datosPersonales = false;
        this.contactsAcord = true;
        this.visible = false;
      }
    },
    validateUserForm() {
      let user = {};
      this.validateFormRepeatedUser = false;
      this.realUserNamePass = true
      for (user of this.allUsers) {
        if (user.userId == this.realUserName && !this.enableEditOptions) {
          this.validateFormRepeatedUser = true;
          this.realUserNamePass = false
        }
      }
    },
    getProperties() {
      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_GETPRO,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            this.propertiesForSuperAdmin(resObject.data.response);
          } 
        })
        .catch(error => {
          // Error server
          if (
            (error.response.status == 404 &&
              (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" ||
                error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) ||
            error.response.status == 500 ||
            error.response.status == 502 ||
            error.response.status == 503 ||
            error.response.status == 504
          ) {
            this.$router.push({ name: "Error" });
          }
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } 
        });
    },
    nu001(userType) {
      switch (userType) {
        case "AGENTE":
          this.enableAdmin = false;
          this.enableAgent = false;
          this.noMoreUsers = true;
          break;

        case "ADMIN":
          this.enableAdmin = false;
          this.enableAgent = true;
          this.noMoreUsers = false;

          break;

        case "SUPER_ADMIN":
          // Un usuario tipo super admin puede generar usuarios tipo administrador.
          // Esta regla va en match con la regla BR_AU_NU002
          this.enableAdmin = true;
          this.enableAgent = false;
          this.noMoreUsers = false;

          break;

        default:
          break;
      }
    },
    getUserDetail(userId, enableDetails, onlyDetail) {
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_CONDU,
          {
            userId: userId
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          if (this.enableEditOptions) {
            this.policiesS = response.data.response.profilePolicies;
            var result = this.policiesS.map(function(el) {
              var o = Object.assign({}, el);
              o.value = false;
              return o;
            });
            this.policiesS = result;
            // Autocomplete configuration data
            for (var i = 0; i < this.policiesS.length; i++) {
              for (var j = 0; j < response.data.response.userPolicies.length; j++) {
                if (
                  this.policiesS[i].travelPolicyId ==
                  response.data.response.userPolicies[j].travelPolicyId
                ) {
                  // Note: policyId's not matching in WS's responses
                  this.policiesS[i].value = true;
                }
              }
            }
          }
          var propertieS = response.data.response.properties;
          var lll = propertieS.filter(idProperties => {
            return idProperties.propertieId.toLowerCase().includes(this.idPropertyAgenteGenerico)
          });
          if (lll.length != 0) {
            this.selectedUser = 'AGENTE_GENERICO';
          } else {
            this.selectedUser = 'AGENTE';
          }

          this.creditType = [];
          this.detailUser = response.data.response;
          // Details user section
          this.userNameD = this.detailUser.userId;
          this.userCommonName = this.detailUser.firstName;
          this.userLastName =
            this.detailUser.lastName != null ? this.detailUser.lastName : "";
          this.userLastName2 =
            this.detailUser.lastName2 != null ? this.detailUser.lastName2 : "";

          this.numEmpD = this.detailUser.employId;
          this.emailD = this.detailUser.email;
          if (this.selectedUser == 'AGENTE_GENERICO' && this.detailUser.userType == 'AGENTE') {
            this.typeUserD = i18n.t("language.posadasCorporate.generals.genericUser");
          } else {
            this.typeUserD = this.detailUser.userType;
          }
          this.verTarifasNeg = this.detailUser.showRates;
          this.verDispo = this.detailUser.showPublicRates;

          if (this.detailUser.active) {
            if (this.$store.getters.gettingLang == "es") {
              this.activeUserD = "Habilitado";
            } else {
              this.activeUserD = "Enabled";
            }
          } else {
            if (this.$store.getters.gettingLang == "es") {
              this.activeUserD = "Deshabilitado";
            } else {
              this.activeUserD = "Unabled";
            }
          }
          this.propertiesListD = [];
          for (let list of this.detailUser.properties) {
            if (!(this.detailUser.userType == 'AGENTE' && list.propertieId == this.idPropertyAgenteGenerico)) {
              this.propertiesListD.push(list);
            }
          }
          this.policiesD = response.data.response.userPolicies;
          this.showDetalle = enableDetails;
          let privilages = {};
          for (privilages of this.detailUser.properties) {
            if (
              privilages.propertieId == "125" ||
              privilages.propertieId == "124" ||
              privilages.propertieId == "118" ||
              privilages.propertieId == "117" ||
              privilages.propertieId == "120" ||
              privilages.propertieId == "119"
            ) {
              this.creditType.push(privilages);
            }
          }
          // Delete payment properties from general properties
          if (onlyDetail) {
            for (var i = 0; i < this.propertiesListD.length; i++) {
              for (var j = 0; j < this.creditType.length; j++) {
                if (this.creditType[j].propertieId == this.propertiesListD[i].propertieId) {
                  this.propertiesListD.splice(i, 1);
                }
              }
            }
          }
          // Autocomplete for edition
          this.autoCompleteEdition(this.detailUser);
        })
        .catch(error => {
          let errorObject = JSON.parse(JSON.stringify(error));
          if (
            errorObject.message == "Network Error" ||
            (error.response.status < 600 && error.response.status > 403) ||
            (error.response.status < 399 && error.response.status > 299) ||
            error.response.status < 200
          ) {
            this.$router.push({ name: "Error" });
          }

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } 
        });
    },
    findingCountry() {
      var codeCountry = "";
      this.codeCountry = "";
      var ls = new SecureLS({ encodingType: "aes" });
      var a = "";
      a = ls.get("Token"); 
      var token = a.data.substr(1);
      var language = ls.get("Language"); 
      if (this.realCountry != "") {
        for (var x = 0; x < this.infoPersonal.paises.length; x++) {
          if (this.realCountry == this.infoPersonal.paises[x].nombre) {
            codeCountry = this.infoPersonal.paises[x].countryCode;
            this.codeCountry = codeCountry;
          }
        }
        // Consultar estados
        this.infoPersonal.estados = [];
        axios
          .get(
            process.env.VUE_APP_HOSTCORPORATEAPI +
              process.env.VUE_APP_CORPORATEAPI +
              process.env.VUE_APP_COUNTRY +
              `/${codeCountry}/` +
              process.env.VUE_APP_STATE,
            {
              withCredentials: true,
              credentials: "include",
              headers: {
                Authorization: "Bearer " + token,
                "Accept-Language": language.data,
                "Content-Type": "application/json"
              }
            }
          )
          .then(res => {
            var resObject = JSON.parse(JSON.stringify(res));
            if (resObject.status == 200 || resObject.status == 201) {
              this.infoPersonal.estados = resObject.data.response;
              var on = [];
              for (var i = 0; i < this.infoPersonal.estados.length; i++) {
                on.push({
                  nombre: this.infoPersonal.estados[i].stateName,
                  code: this.infoPersonal.estados[i].stateCode
                });
              }
              this.infoPersonal.estados = on;
              for (var x = 0; x < on.length; x++) {
                if (this.codeState == on[x].code) {
                  this.infoPersonal.estadoSeleccionado = on[x].nombre;
                }
              }
            } else {
            }
          })
          .catch(error => {
            // Error server
            if (
              (error.response.status == 404 &&
                (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" ||
                  error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) ||
              error.response.status == 500 ||
              error.response.status == 502 ||
              error.response.status == 503 ||
              error.response.status == 504
            ) {
              this.$router.push({ name: "Error" });
            }
            // Error server
            let errorObject = JSON.parse(JSON.stringify(error));
            if (errorObject.message == "Request failed with status code 401") {
              this.clearLocalStorage();
            } 
          });
        // Fin de consultar estados
      }
    },

    chargeCountries() {
      // Consultar paises
      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_COUNTRY,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            var intermidiate = resObject.data.response;
            var intermidiate2 = [];
            this.infoPersonal.paises = [];
            for (var i = 0; i < intermidiate.length; i++) {
              intermidiate2.push({
                nombre: intermidiate[i].countryName,
                countryCode: intermidiate[i].countryCode
              });
            }
            this.infoPersonal.paises = intermidiate2;
          } else {
          }
        })
        .catch(error => {
          // Error server
          if (
            (error.response.status == 404 &&
              (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" ||
                error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) ||
            error.response.status == 500 ||
            error.response.status == 502 ||
            error.response.status == 503 ||
            error.response.status == 504
          ) {
            this.$router.push({ name: "Error" });
          }
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
      // Fin de consultar paises
    },
    chargeProfiles() {
      var profile = this.ls.get("Profile");
      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_GUEST +
            `${profile.data.profileType}`,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            // Filling autocomplete for profiles
            var name = "";
            var middleName = "";
            var fatherSurname = "";
            var mother = "";
            var completeName;

            this.infoPersonal.perfiles = [];
            var justName = "";
            this.profilesAutocomplete = resObject.data.response;
            for (var i = 0; i < resObject.data.response.length; i++) {
              this.infoPersonal.perfiles.push({
                mainNameForService: name,
                middleNameForService: middleName,
                mailContacto: resObject.data.response[i].email,
                nombre:
                  resObject.data.response[i].name + " " + resObject.data.response[i].fatherSurname,
                fiestaRewardsNumber: resObject.data.response[i].fiestaRewardsNumber,
                guestProfileId: resObject.data.response[i].guestProfileId,
                simpleName: justName,
                fatherSurname: fatherSurname,
                motherSurname: mother,
                agentNumber: resObject.data.response[i].employeeNumber,
                rewardsNumber: resObject.data.response[i].fiestaRewardsNumber,
                apreciation: resObject.data.response[i].apreciareClubNumber,
                costCenter: resObject.data.response[i].costCenter,
                streetNameWithNumber: resObject.data.response[
                  i
                ].address.streetNameWithNumber.toUpperCase(),
                locality: resObject.data.response[i].address.locality,
                zipCode: resObject.data.response[i].address.zipCode,
                addressType: resObject.data.response[i].address.addressType,
                // COUNTRY
                country: resObject.data.response[i].address.country,

                // STATE
                state: resObject.data.response[i].address.state
              });
            }
            this.configPerfil.perfiles = this.infoPersonal.perfiles;
            // Profiles autocomple done
          } else {
          }
        })
        .catch(error => {
          // Error server
          if (
            (error.response.status == 404 &&
              (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" ||
                error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) ||
            error.response.status == 500 ||
            error.response.status == 502 ||
            error.response.status == 503 ||
            error.response.status == 504
          ) {
            this.$router.push({ name: "Error" });
          }
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    kotoba() {
      var isTrueSet = this.proforma === "true";
      var emails = [];
      if (this.configPerfil.mailProforma1 != "" && this.configPerfil.mailProforma1 != null) {
        emails.push(this.configPerfil.mailProforma1);
      }
      if (this.configPerfil.mailProforma2 != "" && this.configPerfil.mailProforma2 != null) {
        emails.push(this.configPerfil.mailProforma2);
      }
      if (this.configPerfil.mailProforma3 != "" && this.configPerfil.mailProforma3 != null) {
        emails.push(this.configPerfil.mailProforma3);
      }

      // Get selected policies
      this.policiesS;
      var selectedPolicies = [];
      for (var i = 0; i < this.policiesS.length; i++) {
        if (this.policiesS[i].value) {
          selectedPolicies.push({
            id: Number(this.policiesS[i].travelPolicyId),
            priority: Number(this.policiesS[i].policyPriority)
          });
        }
      }
      //    Get selected propertiesIdList
      var selectedProperties = [];
      for (var i = 0; i < this.superAdProperties.length; i++) {
        if (this.superAdProperties[i].value) {
          selectedProperties.push(Number(this.superAdProperties[i].propertieId));
        }
      }
      if (this.voucher != null && this.voucher != "" && this.voucher != "Ninguno") {
        selectedProperties.push(Number(this.voucher));
      }
      if (this.credito != null && this.credito != "" && this.credito != "Ninguno") {
        selectedProperties.push(Number(this.credito));
      }
      if (this.limite != null && this.limite != "" && this.limite != "Ninguno") {
        selectedProperties.push(Number(this.limite));
      }
      // Difine userType
      var userTypeR = "";
      var nagarada = "";
      if (this.userTypeP == "SUPER_ADMIN") {
        userTypeR = "ADMIN";
        nagarada = "ADMIN Web Site";
      } else if (this.userTypeP == "ADMIN") {
        if (this.mayCreateUserGeneric && this.selectedUser == 'AGENTE_GENERICO') {
          userTypeR = "AGENTE";
          nagarada = "AGENTE Web Site GENERICO";          
        } else {
          userTypeR = "AGENTE";
          nagarada = "AGENTE Web Site";
        }
      }
      //  userDescription
        if(this.enableAgent) {
        if(this.modifyUsers && !selectedProperties.includes("132") && !selectedProperties.includes(132)) {
            selectedProperties.push("132")
          } else if(!this.modifyUsers) {
            const no132 = selectedProperties.filter((element) => element != "132")
            selectedProperties = no132
          }

          if (this.mayCreateUserGeneric && this.selectedUser == 'AGENTE_GENERICO') {
            selectedProperties.push(this.idPropertyAgenteGenerico);
          }
        }

      if (this.configPerfil.mailProforma1 != '' || this.configPerfil.mailProforma2 != '' || this.configPerfil.mailProforma3 != '') {
        selectedProperties.push(this.idPropertyProforma);
      }
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_ATAUSER,
          {
            addres: this.realAddress.toUpperCase(),
            addres2: this.realTown.toUpperCase(),
            centroCostos: this.realNumeroCentro.toUpperCase(),
            cityName: this.realCity.toUpperCase(),
            codigoPostal: this.realZip.toUpperCase(),
            countryCode: this.codeCountry,
            creditStatus: this.ls.get("Profile").data.creditStatus, // ?
            deactivated: true,
            email: this.mailContacto,
            email2: this.infoPersonal.mailContactoConfirmacion,
            emailsProform: emails,
            empleadoNumber: this.realNumeroEmple.toUpperCase(),
            excellentClubPin: this.realNumeroApreciare.toUpperCase(),
            fiestaRewarsNumber: this.realNumeroFiesta.toUpperCase(),
            fiestaRewarsPin: "",
            firstName: this.realFirstName.toUpperCase(),
            lastName: this.realLastName.toUpperCase(),
            middleName: "",
            motherMaidenName: this.realLastName2 != null ? this.realLastName2.toUpperCase() : "",
            numberPhone: this.infoPersonal.numTelefonico,
            numberType: this.pickedTelelefonoUf,
            password: this.contrasenaUsuario,
            policies: selectedPolicies,
            profileIdNumber: 0, 
            propertiesIdList: selectedProperties,
            recibeNewsLetter: 0,
            showC2K: this.ls.get("Profile").data.ratesPermissionsResponse.showC2K,
            showFR: this.ls.get("Profile").data.ratesPermissionsResponse.showFR,
            showINT: this.ls.get("Profile").data.ratesPermissionsResponse.showINT,
            showPIF: this.ls.get("Profile").data.ratesPermissionsResponse.showPIF,
            showPublicRates: this.showPublicRatesValue,
            showRates: this.showRatesValue,
            stateCode: this.codeState,
            tipoPerfil: "",
            userId: this.realUserName,
            userType: userTypeR,
            userTypeDescription: nagarada
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          this.banLoaderCU = false;
          this.showModalUsuario();
          this.reset();
          this.tsss();
        })
        .catch(error => {
          this.banLoaderCU = false;
          let errorObject = JSON.parse(JSON.stringify(error));
          if (error.response.status == 404 && error.response.data.errorCode == 'RSP_USER05') {
            this.isModalDuplicado = true;
            this.datosGeneralesForm = true;
            setTimeout(() => {
              this.visible = true;
              this.realUserNamePass = false;
              this.repeatedUserModal = true;
            }, 500);
          } else {
            if (
              errorObject.message == "Network Error" ||
              (error.response.status < 600 && error.response.status > 403) ||
              (error.response.status < 399 && error.response.status > 299) ||
              error.response.status < 200
            ) {
              this.$router.push({ name: "Error" });
            } 
  
            if (errorObject.message == "Request failed with status code 401") {
              this.clearLocalStorage();
            }
          }
        });
    },
    /*Eventos para cambios en el ancho de la pagina*/
    getWindowWidth: function(event) {
      this.windowWidth = document.documentElement.clientWidth;
      this.windowWidth > 991 ? (this.device = "desktop") : (this.device = "mobile");
    },
    // Perfiles existentes methods
    outsidePerfEx() {
      this.configPerfil.buscador = false;
    },
    filteredListPerfEx() {
      return (this.configPerfil.perfilesLista = this.configPerfil.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.configPerfil.search.toLowerCase());
      }));
    },
    cambiaValuePerfEx(perfil) {
      return (this.configPerfil.search = perfil);
    },
    passwordValidate() {
      if (this.contrasenaUsuario == this.contrasenaConfirma) {
        this.passwordMatch = true;
      } else {
        this.passwordMatch = false;
      }
    },

    closeExpiredModal() {
      this.isExpiredModalVisible = false;
      var ls = new SecureLS({ encodingType: "aes" });
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true;
    },
    onThere() {
      this.items = this.$store.getters.getUsers;
    },
    onHere() {
      this.items = this.$store.getters.getUsers;
      this.items = this.items.filter(titulo => {
        return titulo.userName.toLowerCase().startsWith(this.filtroUsuarioDado.toLowerCase());
      });
    },
    filteredListUsuarios() {},
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
      this.openEye = this.openEye === "__eyeIcon" ? "__closeEyeIcon" : "__eyeIcon";
    },
    switchVisibilityConfirm() {
      this.passwordFieldTypeConfirm =
        this.passwordFieldTypeConfirm === "password" ? "text" : "password";
      this.openEyeConfirm = this.openEyeConfirm === "__eyeIcon" ? "__closeEyeIcon" : "__eyeIcon";
    },
    showModalUsuario() {
      this.dataTable();
      this.isModalUsuarioNuevo = true;
      if (this.actionUsuario === "modificar") {
        this.modalTitle = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.usuModExito"
        );
        this.ModalBody = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.text1"
        );
      } else if (this.actionUsuario === "crear") {
        this.modalTitle = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.newUsuExito"
        );
        this.ModalBody = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.text2"
        );
      } else {
        this.modalTitle = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.errorDatInvalid"
        );
        this.ModalBody = i18n.t(
          "language.posadasCorporate.tablaUsuariosRegistrados.modalGuaMod.errorDatInvalid"
        );
      }
    },
    closeModalUsuario() {
      this.isModalUsuarioNuevo = false;
    },
    showModalDuplicado() {
      this.isModalDuplicado = true;
    },
    closeModalDuplicado() {
      this.isModalDuplicado = false;
      setTimeout(() => {
        document.getElementById("campoUsuarioId").focus();
        var ele = document.getElementById("campoUsuarioId");
        var posicion = ele.getBoundingClientRect();
        window.scrollTo(0, posicion.y)
      }, 500);
    },
    showModalEliminar(usuario) {
      //abrir modal para eliminar
      this.isModalEliminar = true;
      this.selectDelete = usuario;
    },
    closeModalEliminar() {
      this.isModalEliminar = false;
    },
    showModalHeredar(array) {
      this.isModalEliminar = false;
      this.isModalHeredar = true;
    },
    limpiarData() {
      this.banLoaderHeredar = false;
      this.usuarioHeredar = "";
      this.selectDelete = "";
    },
    closeModalHeredar() {
      this.limpiarData();
      this.isModalHeredar = false;
    },
    showModalHeredado(lugar) {
      this.banLoaderHeredar = true;
      if (lugar == 1) {
        this.usuarioHeredar = "";
      }
      this.delUser();
    },
    closeModalHeredado() {
      this.isModalHeredado = false;
      this.usuarioHeredar = "";
      this.selectDelete = "";
    },
    dataTable() {
      this.enableLoader = true;
      var _this = this;
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
            process.env.VUE_APP_CORPORATEAPI +
            process.env.VUE_APP_LISTUSERS,
          {},
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          var data = [],
            respuesta = response.data.response;
          this.allUsers = respuesta;
          for (var i = 0; i < respuesta.length; i++) {
            if (respuesta[i].active) {
              if (this.ls.get("Language").data == "es") {
                respuesta[i].active = "Habilitado";
              } else {
                respuesta[i].active = "Enable";
              }
            } else {
              if (this.ls.get("Language").data == "es") {
                respuesta[i].active = "Deshabilitado";
              } else {
                respuesta[i].active = "Disable";
              }
            }
            if (respuesta[i].lastLogin == "Sin accesso") {
              respuesta[i].lastLogin = "Nunca";
            } else if (respuesta[i].lastLogin == "No access") {
              respuesta[i].lastLogin = "Never";
            } else {
              respuesta[i].lastLogin = respuesta[i].lastLogin.replace(/-/g, "/");
            }
          }
          Object.keys(respuesta).forEach(key =>
            data.push({
              userName: respuesta[key].userId,
              name: respuesta[key].firstName,
              lastName: respuesta[key].lastName,
              into: respuesta[key].lastLogin,
              status: respuesta[key].active
            })
          );
          _this.items = data;
          this.$store.commit("usersTable", data);
          this.enableLoader = false;
        })
        .catch(error => {
          this.enableLoader = false;

          let errorObject = JSON.parse(JSON.stringify(error));
          if (
            errorObject.message == "Network Error" ||
            (error.response.status < 600 && error.response.status > 403) ||
            (error.response.status < 399 && error.response.status > 299) ||
            error.response.status < 200
          ) {
            this.$router.push({ name: "Error" });
          }

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } 
        });
    },
    cambiaPerfil(perfil, id) {
      this.givenProfile = "";
      setTimeout(() => {
        this.givenProfile = id;
      }, 1);
      return (this.infoPersonal.perfilDado = perfil);
    },
    cambiaFiltro(filtro) {
      return (this.filtroUsuarioDado = filtro);
    },
    cambiaPais(pais) {
      this.banSelectedPais = true;
      if (this.realCountry != pais) {
        this.realCountry = pais;
        setTimeout(() => {
          this.findingCountry();
        }, 10);
      }
    },
    cambiaEstado(estado) {
      this.codeState = estado;
      return (this.infoPersonal.estadoSeleccionado = estado);
    },
    // Cerrar inputs
    outsidePerfil(e) {
      this.infoPersonal.perfil = false;
    },
    outsideTitulo(e) {
      this.infoPersonal.titulo = false;
    },
    outsideFiltro(e) {
      this.infoPersonal.filtroUsuario = false;
    },

    outsidePais(e) {
      this.infoPersonal.pais = false;
    },
    outsideEstado(e) {
      this.infoPersonal.estado = false;
    },
    modificarUsuario(user) {
      this.enableEditOptions = true;
      this.titleNuevoUsuario = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.editUsuario"
      );
      this.titleBtnContraseña = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contContrasenaReg"
      );
      this.titleTitleContraseña = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contrasenaReg"
      );
      this.showUsuario = true;
      this.showEditar = true;
      this.actionUsuario = "modificar";
      this.configPerfil.showPerfiles = false;
      this.realUserName = user.item.userName;
      this.realCity = "";
      this.pickedTelelefonoUf = "";
      this.infoPersonal.numTelefonico = "";
      this.realCountry = "";
      this.codeCountry = "";
      this.mailContactoConfirm = "";
      this.mailContacto = "";
      this.infoPersonal.estadoSeleccionado = "";
      this.repeatedUserModal = false;
      this.resetConfigEdition();
      this.getUserDetailSesssion(this.ls.get("Profile").data.username, false);
      this.getUserDetail(user.item.userName, false, false);
    },
    crearUsuario() {
      this.enableEditOptions = false;
      this.titleNuevoUsuario = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.crearNuevoUsuario"
      );
      this.titleBtnContraseña = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contContrasena"
      );
      this.titleTitleContraseña = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.contrasena"
      );
      this.showUsuario = true;
      this.showEditar = true;
      this.actionUsuario = "crear";
      this.pickedTelelefonoUf = "";
      this.infoPersonal.estadoSeleccionado = "";
      this.realCity = "";
      this.infoPersonal.numTelefonico = "";
      this.realCountry = "";
      this.codeCountry = "";
      this.configPerfil.showPerfiles = true;
      this.resetConfigEdition();
      this.getUserDetailSesssion(this.ls.get("Profile").data.username, false);
      this.clearForm();
    },
    crearUsuarioForm() {
      this.banLoaderCU = true;
      if (this.enableEditOptions) {
        this.editUserW();
      } else {
        this.kotoba();
      }
    },
    reset() {
      this.mailContacto = "";
      this.mailContactoConfirm = "";
      this.emailMatch = true;
      this.contrasenaUsuario = "";
      this.passwordMatch = true;
      this.passwordNot10 = true;
      this.contrasenaConfirma = "";
      this.showDetalle = false;
      this.showUsuario = true;
      this.showEditar = false;
      this.visible = true;
      this.datosGeneralesPasos = true;
      this.datosGeneralesForm = true;
      this.datosConfigForm = false;
      this.titleNuevoUsuario = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.crearNuevoUsuario"
      );
      this.infoPersonal.datosPersonales = true;
      this.infoPersonal.datosContacto = true;
      this.configPerfil.datosTipoUsuario = true;
      this.configPerfil.datosMetodoPago = true;
      this.configPerfil.datosTarifasPoliticas = true;
      this.voucher = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
      );
      this.credito = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
      );
      this.limite = i18n.t(
        "language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno"
      );
      this.tdc = i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno");
      this.token = i18n.t("language.posadasCorporate.tablaUsuariosRegistrados.confiPerfil.ninguno");
      this.proforma = "noEnviarProforma";
      this.checkedUser = "admin";
      this.configPerfil.mailProforma1 = "";
      this.configPerfil.mailProforma2 = "";
      this.configPerfil.mailProforma3 = "";
      this.configPerfil.showPerfiles = false;
      this.infoPersonal.perfilDado = '';
    },
    resetCreation() {
      this.contrasenaUsuario = "";
      this.contrasenaConfirma = "";
      this.realFirstName = "";
      this.realLastName = "";
      this.realLastName2 = "";
      this.realNumeroEmple = "";
      this.realNumeroFiesta = "";
      this.realNumeroApreciare = "";
      this.realNumeroCentro = "";
      this.mailContacto = "";
      this.mailContactoConfirm = "";

      this.infoPersonal.mailContactoConfirmacion = "";
      this.realAddress = "";
      this.realTown = "";
      this.realZip = "";
      this.realCity = "";
      this.codeCountry = "";
      this.codeState = "";

      this.infoPersonal.numTelefonico = "";
      this.pickedTelelefonoUf = "";
      this.selectedUser = 'AGENTE';
      this.banSelectedPais = false;

    },
    resetGenerales() {}
  },
  computed: {
    isDisabledEstado() {
      if (this.banSelectedPais) {
        return false;
      } else {
        return true;
      }
    },
    lists() {
      const items = this.policiesS;
      // Return just page of items needed
      return items.slice(
        (this.currentPagePols - 1) * this.perPagePols,
        this.currentPagePols * this.perPagePols
      );
    },
    rows() {
      return this.filtered.length;
    },
    filtered() {
      if (this.filters.userName != null) {
        if (this.filters.userName.length > 1) {
          this.filterSearch = this.filters.userName;
            const filtered = this.items.filter(item => item.userName.includes(this.filterSearch))
             
        this.rowsNumber = filtered.length
           
          return filtered.length > 0 ? filtered : [];
        } else {
        this.rowsNumber = this.items.length

          return this.items;
        }
      } else {
        this.rowsNumber = this.items.length
        return this.items;
      }
    },
    // infoPersonal.buscador
    filteredListPerfiles() {
      return this.infoPersonal.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.infoPersonal.perfilDado.toLowerCase());
      });
    },

    filteredListPaises() {
      return this.infoPersonal.paises.filter(pais => {
        return pais.nombre.toLowerCase().includes(this.realCountry.toLowerCase());
      });
    },
    filteredListEstado() {
      return this.infoPersonal.estados.filter(estado => {
        return estado.nombre
          .toLowerCase()
          .includes(this.infoPersonal.estadoSeleccionado.toLowerCase());
      });
    },
    // Validador
    isDisabledPersonales() {
      if (
        this.realUserName.length > 1 &&
        this.realFirstName.length > 2 &&
        this.realLastName.length > 2 &&
        !this.repeatedUserModal
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContacto() {
      if (
        this.infoPersonal.numTelefonico.length > 9 &&
        this.mailContacto.length > 3 &&
        this.pickedTelelefonoUf.length > 2 &&
        this.banSelectedPais &&
        this.validateEmail(this.mailContacto) &&
        (this.infoPersonal.mailContactoConfirmacion == "" ||
          this.validateEmail(this.infoPersonal.mailContactoConfirmacion)) &&
        this.mailContactoConfirm.length > 3 &&
        this.validateEmail(this.mailContactoConfirm) &&
        this.emailMatch &&
        this.codeCountry.length != 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormularioEdition() {
      if (
        this.realUserName.length > 1 &&
        this.pickedTelelefonoUf.length > 2 &&
        this.realFirstName.length > 2 &&
        this.realLastName.length > 2 &&
        this.infoPersonal.numTelefonico.length > 9 &&
        this.mailContacto.length > 3 &&
        this.banSelectedPais &&
        this.validateEmail(this.mailContacto) &&
        (this.validateEmail(this.infoPersonal.mailContactoConfirmacion) ||
          this.infoPersonal.mailContactoConfirmacion == "") &&
        (this.validateEmail(this.configPerfil.mailProforma1) ||
          this.configPerfil.mailProforma1 == "") &&
        (this.validateEmail(this.configPerfil.mailProforma2) ||
          this.configPerfil.mailProforma2 == "") &&
        (this.validateEmail(this.configPerfil.mailProforma3) ||
          this.configPerfil.mailProforma3 == "") &&
        this.editValidation &&
        this.mailContactoConfirm.length > 3 &&
        this.validateEmail(this.mailContactoConfirm) &&
        this.emailMatch &&
        this.contrasenaUsuario == this.contrasenaConfirma && 
        this.codeCountry.length != 0 && (this.proforma !== 'true' || this.validateEmail(this.configPerfil.mailProforma1) )
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledFormulario() {
      if (
        this.realUserName.length > 1 &&
        this.pickedTelelefonoUf.length > 2 &&
        this.realFirstName.length > 2 &&
        this.realLastName.length > 2 &&
        this.infoPersonal.numTelefonico.length > 9 &&
        this.mailContacto.length > 3 &&
        this.contrasenaUsuario.length > 9 &&
        this.contrasenaConfirma.length > 9 &&
        this.passwordMatch === true &&
        this.banSelectedPais &&
        this.validateEmail(this.mailContacto) &&
        (this.validateEmail(this.infoPersonal.mailContactoConfirmacion) ||
          this.infoPersonal.mailContactoConfirmacion == "") &&
        (this.validateEmail(this.configPerfil.mailProforma1) ||
          this.configPerfil.mailProforma1 == "") &&
        (this.validateEmail(this.configPerfil.mailProforma2) ||
          this.configPerfil.mailProforma2 == "") &&
        (this.validateEmail(this.configPerfil.mailProforma3) ||
          this.configPerfil.mailProforma3 == "") &&
        this.mailContactoConfirm.length > 3 &&
        this.validateEmail(this.mailContactoConfirm) &&
        this.emailMatch &&
        this.contrasenaUsuario == this.contrasenaConfirma &&
        !this.isDisabledPersonales &&
        this.codeCountry.length != 0 &&
        !this.validateFormRepeatedUser && (this.proforma !== 'true' || this.validateEmail(this.configPerfil.mailProforma1) )
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledUsuario() {
      if (this.checkedUser.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledPago() {
      if (this.voucher.length > 1 && this.credito.length > 1 && this.limite.length > 1) {
        return false;
      } else {
        return true;
      }
    }
  },
  filters: {
    // infoPersonal.buscador
    resalt: function(value, valueFromSearch) {
      if (!value) return "";
      valueFromSearch != ""
        ? (value = value.replace(
            valueFromSearch,
            '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + "</span>"
          ))
        : (value = value);
      return value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/config.scss";
@import "../../../assets/scss/views/v_tablaUsuariosRegistrados.scss";
.inputUppercase {
  text-transform: uppercase;
}
.verMas {
  font-weight: 500;
  cursor: pointer;
}
.pasos {
  color: $grayBrownish;
  font-size: $font-size-biglarge;
  font-weight: 300;
}
.ativePaso {
  color: #0c5458;
  font-size: $font-size-biglarge;
  font-weight: 500;
}
.datos {
  i {
    font-size: 18px;
  }
  .navi {
    float: right;
  }
  .editarDatos {
    font-size: $font-size-base;
    color: #0c5458;
    float: right;
  }
}
.campos {
  border-bottom: 1px solid $colorBase5;
  &:last-child {
    border-bottom: none;
  }
  .datos {
    padding-bottom: 24px;
  }
  .tituloDatos {
    margin: 0;
    color: $grayBrownish;
    font-size: $font-size-large;
    font-weight: 500;
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .camposActive {
    color: #0c5458;
    font-weight: 500;
  }
  .tituloDatosEditar {
    margin: 0;
    color: #006900;
    font-weight: 500;
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .cardsInfo {
    background-color: #d1ecf1;
    .nota {
      font-size: $font-size-base;
      color: $grayShadeDark;
    }
    .notaAzul {
      font-size: $font-size-base;
      color: $colorBase2;
      font-weight: 500;
    }
  }
}
.container-siderbarTop {
  padding-top: 140px;
}
.superTitle {
  height: 26px;
  font-size: $font-size-biglarge;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 0.4px;
  margin-bottom: 16px;
}
.reservaciones {
  width: 100%;
}
.filtros {
  font-size: $font-size-base;
  font-weight: 500;
  .iconFiltros {
    font-size: $font-size-biglarge;
    vertical-align: middle;
  }
}
.costosTable {
  width: 50%;
  display: inline-block;
  padding-bottom: 10px;
}
@media only screen and (max-width: 736px) {
  .container-siderbarTop {
    padding-top: 130px;
  }
  .costosTable {
    width: 100%;
    display: inline-block;
  }
}
@media (min-width: 992px) {
  .datos {
    .botonesInfo {
      margin-left: auto;
    }
  }
}
.custom-inputsearch {
  position: relative;
  text-align: right;
  padding-bottom: 25px;
  input {
    border-radius: 4px;
    border: solid 1px #bac9d8;
    padding: 8px;
    height: 34px;
    min-width: 230px;
  }
  i {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 18px;
    color: #005a83;
    height: 34px;
  }
  @media (max-width: 991px) {
    input {
      width: 100%;
    }
  }
}
#name,
#lastName,
#into,
#status,
#options {
  display: none;
}
// .form-element {
//   margin-top: 0 !important;
// }

.c-modal-footer {
  button {
    padding-bottom: 30px !important;
  }
}
.filtrado {
  display: flex;
  align-items: center;
  input {
    width: 30%;
    border: none;
    outline: none !important;
    &:focus {
      border-radius: 0 !important;
      box-shadow: unset !important;
    }
  }
}
.relative {
  position: relative;
}
.buttonEye {
  height: 55%;
  width: 10%;
  position: absolute;
  right: 17px;
  top: 30px;
  cursor: pointer;
}
.buscadorCustom {
  left: 185px;
  top: 30px;
}
.search-Custom {
  position: absolute;
  top: 7px;
  left: 230px;
}
.bold {
  font-weight: 500 !important;
}
</style>
